// Locales supported here: en-US, es-ES, ja-JP, ko-KR, th-TH, vi-VN

const TRANSLATIONS = {
  'en-US': {
    // Outline page
    'outline.editModeActive': 'Edit Mode Active',
    'outline.tooltip.saveChanges': 'Save Changes',
    'outline.tooltip.editProgramName': 'Edit program name',
    'outline.tooltip.download': 'Download',
    'outline.tooltip.exitEditMode': 'Exit edit mode',
    'outline.tooltip.editOutlineContent': 'Edit outline content',
    'outline.tooltip.edit': 'Edit',
    'outline.tooltip.collapseDetails': 'Collapse to hide details',
    'outline.tooltip.expandDetails': 'Expand to view details',
    'outline.tooltip.removeItem': 'Remove this item',

    'outline.btn.save': 'Save',
    'outline.btn.saving': 'Saving...',
    'outline.btn.cancel': 'Cancel',
    'outline.btn.startOver': 'Start Over',
    'outline.btn.generateProgram': 'Generate Program',
    'outline.btn.goBack': 'Go Back',
    'outline.btn.discard': 'Discard',
    'outline.btn.saveChanges': 'Save changes',
    'outline.btn.yesRemove': 'Yes, Remove',
    'outline.btn.yesGenerate': 'Yes, Generate',

    'outline.title.suffix': 'Program Outline',
    'outline.placeholder.enterProgramName': 'Enter program name',

    'outline.section.learners': 'Learners',
    'outline.section.programStructure': 'Program Structure',
    'outline.section.programLength': 'Program Length',
    'outline.section.overview': 'Overview:',

    'outline.structure.summary': '{modules} Module(s) / {units} Unit(s) / {sessions} Session(s)',
    'outline.duration.minutes': '{minutes} minutes',
    'outline.duration.totalMinutes': '({minutes} minutes total)',

    // Duration formatting (used by formatDuration in utils.js — e.g. "2 hours and
    // 15 minutes"). These were missing from en-US, so the raw keys leaked into the
    // Teaching Plan / Outline (e.g. "2 duration.hours duration.and 15 duration.minutes").
    'duration.minutes': 'minutes',
    'duration.hour': 'hour',
    'duration.hours': 'hours',
    'duration.and': 'and',
    'outline.label.moduleWithIndex': 'Module {index}: {title}',
    'outline.label.unitWithIndex': 'Unit {index}: {title}',
    'outline.label.sessionWithIndex': 'Session {index}: {title}',
    'outline.section.sessionLearningObjectives': 'Session learning objectives:',

    'outline.educator': 'Educator',
    'outline.learner': 'Learner',
    'outline.ksab.knowledge': 'Knowledge',
    'outline.ksab.skills': 'Skills',
    'outline.ksab.attitudes': 'Attitudes',
    'outline.ksab.behaviours': 'Behaviours',

    'outline.frameworksAligned': 'Frameworks Aligned',
    'outline.noFrameworksAligned': 'No frameworks aligned for this module',

    'outline.targetGroup.general': 'General Public',
    'outline.targetGroup.children': 'Children',
    'outline.targetGroup.teens': 'Teenagers',
    'outline.targetAge.8_9': 'Ages 8-9',
    'outline.targetAge.10_12': 'Ages 10-12',
    'outline.targetAge.13_14': 'Ages 13-14',
    'outline.targetAge.15_18': 'Ages 15-18',
    'outline.targetAge.allAges': 'All Ages',
    'outline.targetAge.workforce': 'Workforce',
    'outline.targetTier.T1': 'Lower Primary (Ages 7–9)',
    'outline.targetTier.T2': 'Upper Primary (Ages 10–12)',
    'outline.targetTier.T3': 'Middle School (Ages 13–14)',
    'outline.targetTier.T4': 'High School (Ages 15–17)',
    'outline.targetTier.T5': 'Tertiary (Ages 18–22)',
    'outline.targetTier.T6': 'General Public (All Ages)',
    'outline.targetTier.T7': 'Workforce',

    'outline.toast.editNotAvailableEnglish': 'Editing is not available for English. Please select another language.',
    'outline.toast.failedOpenPdf': 'Failed to open PDF',
    'outline.toast.failedSaveOutline': 'Failed to save outline',
    'outline.toast.failedRemoval': 'Failed to complete removal operation',

    'outline.dialog.removeItem.title': 'Are you sure you want to remove this {type}?',
    'outline.dialog.removeProgram.html': "Are you sure you want to remove this program?<br/>This action cannot be undone.",
    'outline.dialog.lastItem.title.program': 'Warning: Delete Current Program',
    'outline.dialog.lastItem.title.module': 'Warning: Delete Module',
    'outline.dialog.lastItem.title.unit': 'Warning: Delete Unit',
    'outline.dialog.lastItem.body.program.html':
      "This is the last {type} in the program.<br/>Removing this will <strong>delete the entire current program</strong> and create a new program.<br/>Are you sure you want to proceed? This action cannot be undone.",
    'outline.dialog.lastItem.body.module.html':
      "This is the last {type} in this module.<br/>Removing this {type} will also <strong>delete the entire module</strong>.<br/>Are you sure you want to proceed? This action cannot be undone.",
    'outline.dialog.lastItem.body.unit.html':
      "This is the last {type} in this unit.<br/>Removing this {type} will also <strong>delete the entire unit</strong>.<br/>Are you sure you want to proceed? This action cannot be undone.",
    'outline.dialog.lastItem.confirm.program': 'Yes, Delete Program',
    'outline.dialog.lastItem.confirm.module': 'Yes, Delete Module',
    'outline.dialog.lastItem.confirm.unit': 'Yes, Delete Unit',

    'outline.dialog.generate.body.html':
      "Are you sure you'd like to generate this program with <b>{count} session(s)?</b><br/>Once it's created, you won't be able to make changes, and you'll be billed for the generated session(s).",

    'outline.dialog.unsaved.title': 'Unsaved changes',
    'outline.dialog.unsaved.body': 'You have unsaved changes. Save them now or they will be discarded.',

    // Outline PDF/HTML documents
    'outlineDoc.title.prefix': 'Program Outline for',
    'outlineDoc.viewType.educator': 'Educator View',
    'outlineDoc.viewType.learner': 'Learner View',
    'outlineDoc.meta.learners': 'Learners:',
    'outlineDoc.meta.programStructure': 'Program Structure:',
    'outlineDoc.meta.programLength': 'Program Length:',
    'outlineDoc.meta.notSpecified': 'Not specified',
    'outlineDoc.structure.modules': 'Module(s)',
    'outlineDoc.structure.units': 'Unit(s)',
    'outlineDoc.structure.sessions': 'Session(s)',
    'outlineDoc.section.overview': 'Overview:',
    'outlineDoc.ksab.label': 'KSAB:',
    'outlineDoc.ksab.knowledge': 'Knowledge',
    'outlineDoc.ksab.skills': 'Skills',
    'outlineDoc.ksab.attitudes': 'Attitudes',
    'outlineDoc.ksab.behaviours': 'Behaviours',
    'outlineDoc.dqCode.label': 'DQ Code(s):',
    'outlineDoc.module.label': 'Module',
    'outlineDoc.unit.label': 'Unit',
    'outlineDoc.session.label': 'Session',
    'outlineDoc.session.learningObjectives': 'Session Learning Objectives:',
    'outlineDoc.frameworksAligned': 'Frameworks Aligned:',
    'outlineDoc.noFrameworks': 'No frameworks aligned for this program',
    'outlineDoc.footer.copyright': 'DQ LAB Pte Ltd. All rights reserved. Powered by DQ',
    'outlineDoc.footer.trademark': 'is a registered trademark of DQ LAB Pte Ltd.',

    // Teaching Plan PDF/HTML documents
    'teachingPlan.title.suffix': 'Educator Teaching Plan',
    'teachingPlan.meta.learners': 'Learners:',
    'teachingPlan.meta.programStructure': 'Program Structure:',
    'teachingPlan.meta.programLength': 'Program Length:',
    'teachingPlan.meta.notSpecified': 'Not specified',
    'teachingPlan.structure.modules': 'Module(s)',
    'teachingPlan.structure.units': 'Unit(s)',
    'teachingPlan.structure.sessions': 'Session(s)',
    'teachingPlan.section.overview': 'Overview',
    'teachingPlan.section.preparingClass': 'Preparing Your Class',
    'teachingPlan.prep.beforeBeginning': 'Before beginning the program:',
    'teachingPlan.prep.internetAccess': 'Ensure your classroom has {bold1} and {bold2} (computers or tablets).',
    'teachingPlan.prep.internetAccessBold1': 'internet access',
    'teachingPlan.prep.internetAccessBold2': 'digital devices',
    'teachingPlan.prep.studentAccounts': 'Confirm all students have accounts and can log in to {link}.',
    'teachingPlan.prep.studentAccountsLink': 'www.dqforall.com',
    'teachingPlan.prep.websiteBlocked': 'If the website is blocked, ask your {bold} to whitelist or unblock it.',
    'teachingPlan.prep.websiteBlockedBold': 'system administrator',
    'teachingPlan.prep.headphones': 'Encourage students to bring {bold} (some activities include video or audio).',
    'teachingPlan.prep.headphonesBold': 'headphones',
    'teachingPlan.module.label': 'Module',
    'teachingPlan.unit.label': 'Unit',
    'teachingPlan.session.label': 'Session',
    'teachingPlan.session.untitled': 'Untitled Session',
    'teachingPlan.session.learningObjectives': 'Session Learning Objectives',
    'teachingPlan.table.estimatedTime': 'Estimated Time',
    'teachingPlan.table.segment': 'Segment',
    'teachingPlan.table.activities': 'Activities',
    'teachingPlan.table.description': 'Description',
    'teachingPlan.table.minutes': 'min',
    'teachingPlan.segment.introduction': 'Introduction',
    'teachingPlan.segment.introduction.activity1': 'View content slides',
    'teachingPlan.segment.introduction.activity2': 'Watch introduction video',
    'teachingPlan.segment.introduction.description': 'Students are introduced to the session topic and learning objectives.',
    'teachingPlan.segment.preAssessment': 'Pre-Assessment',
    'teachingPlan.segment.preAssessment.activity1': 'Complete assessment questions',
    'teachingPlan.segment.preAssessment.activity2': 'Self-evaluation',
    'teachingPlan.segment.preAssessment.description': 'Students complete a pre-assessment to gauge their existing knowledge on the topic.',
    'teachingPlan.segment.learningObjective': 'Learning Objective',
    'teachingPlan.segment.slo.activity1': 'Interactive activities',
    'teachingPlan.segment.slo.activity2': 'Guided practice',
    'teachingPlan.segment.slo.activity3': 'Answer polls',
    'teachingPlan.segment.slo.activity4': 'Apply concepts',
    'teachingPlan.segment.slo.description': 'Students engage with learning content through interactive activities.',
    'teachingPlan.segment.mainContent': 'Main Content',
    'teachingPlan.segment.mainContent.activity1': 'Interactive learning activities',
    'teachingPlan.segment.mainContent.activity2': 'Guided exploration',
    'teachingPlan.segment.mainContent.activity3': 'Group discussions',
    'teachingPlan.segment.mainContent.description': 'Students engage with the core learning content through interactive activities and discussions.',
    'teachingPlan.segment.reflection': 'Reflection',
    'teachingPlan.segment.reflection.activity1': 'Personal reflection',
    'teachingPlan.segment.reflection.activity2': 'Answer reflection questions',
    'teachingPlan.segment.reflection.activity3': 'Share insights',
    'teachingPlan.segment.reflection.description': 'Students reflect on their learning and share key takeaways with peers.',
    'teachingPlan.segment.postAssessment': 'Post-Assessment',
    'teachingPlan.segment.postAssessment.activity1': 'Complete assessment questions',
    'teachingPlan.segment.postAssessment.activity2': 'Review answers',
    'teachingPlan.segment.postAssessment.description': 'Students complete a post-assessment to demonstrate their understanding of the concepts learned.',
    'teachingPlan.segment.recap': 'Recap',
    'teachingPlan.segment.recap.activity1': 'Review key concepts',
    'teachingPlan.segment.recap.activity2': 'Q&A session',
    'teachingPlan.segment.recap.activity3': 'Summary',
    'teachingPlan.segment.recap.description': 'Key learning points are reviewed and reinforced to ensure understanding.',
    'teachingPlan.section.teacherNotes': 'Teacher Notes',
    'teachingPlan.notes.note1': 'Keep an open, curious classroom environment.',
    'teachingPlan.notes.note2': 'Reinforce lessons throughout by checking in with students after each session recap using live group discussions or quick reflection activities.',
    'teachingPlan.notes.note3': 'Track progress and impact via your {bold}.',
    'teachingPlan.notes.note3Bold': 'Powered by DQ School Dashboard',
    'teachingPlan.footer.copyright': 'DQ LAB Pte Ltd. All rights reserved. Powered by DQ',
    'teachingPlan.footer.trademark': 'is a registered trademark of DQ LAB Pte Ltd.',

    // Preview page
    'preview.editModeActive': 'Edit Mode Active',
    'preview.preAssessment': 'Pre Assessment',
    'preview.postAssessment': 'Post Assessment',
    'preview.deck.download': 'Download HTML',
    'preview.deck.preparing': 'Preparing HTML…',
    'preview.deck.failed': 'Could not prepare the slides for download. Please try again.',
    'preview.deck.noVideo': 'Video not available',
    'preview.deck.slideCount': '{count} slides',
    'preview.deck.noSlides': 'No slides yet',
    'preview.assessment.quickTestFirst': "Let's Take a Quick Test First!",
    'preview.assessment.testKnowledgeSkills': 'Let’s Test Your Knowledge And Skills!',
    'preview.assessment.introAlt': 'Assessment Intro',
    'preview.assessment.introTitle': 'Assessment Introduction',
    'preview.assessment.noQuestions': 'No questions available.',
    'preview.tooltip.exitEditMode': 'Exit edit mode',
    'preview.tooltip.editNotAvailableEnglish': 'Editing is not available for English-only content',
    'preview.tooltip.editToggleLanguage': 'Editing is only available for non-English language versions. Toggle to other language to edit.',
    'preview.tooltip.editSlideContent': 'Edit slide content',
    'preview.btn.viewNextSession': 'View Next Session',
    'preview.btn.viewNextSegment': 'View Next Segment',
    'preview.btn.hide': 'Hide',
    'preview.btn.unhide': 'Unhide',
    'preview.tts.voice': 'Voice',
    'preview.tts.noVoices': 'No voices available yet',
    'preview.tts.rate': 'Rate',
    'preview.tts.pitch': 'Pitch',
    'preview.tts.volume': 'Volume',
    'preview.segment.introduction': 'Introduction',
    'preview.segment.reflection': 'Reflection',
    'preview.segment.recap': 'Recap',
    'preview.segment.sessionScore': 'Session Score',
    'preview.toast.failedSave': 'Failed to save changes. Please try again.',
    'preview.toast.ttsBrowser': 'Text to speech seems to have an issue with your browser. Please upgrade the browser version or try another browser.',
    'preview.toast.editNotAvailableEnglish': 'Editing is not available for English-only content.',
    'preview.toast.editToggleLanguage': 'Editing is only available for non-English language versions. Please toggle to view other language content.',
    'preview.toast.outlineNotReady': 'Learning program outline not ready yet!',
    'preview.toast.sessionNotAvailable': 'Session "{title}" is not available.',
    'preview.toast.sessionGenerating': 'Session "{title}" is still generating. Please wait.',
    'preview.selectSession': 'Select a session from the menu to view content',
    'preview.assessmentModal.hideConfirm': 'Hiding the assessment will remove both the pre- and post-assessments for your students from all sessions in this entire module.<br/>Are you sure you want to continue?',
    'preview.assessmentModal.unhideConfirm': 'When you unhide this assessment, both the pre- and post-assessments from all sessions in this module will become visible to your students again.<br/>Are you sure you want to continue?',
    'preview.error.slideLayoutNotFound': 'Error: Slide layout not found',
    'preview.loadingSlides': 'Loading slides...',
    'preview.sidebar.moduleWithIndex': 'Module {index}: {title}',
    'preview.sidebar.unitWithIndex': 'Unit {index}: {title}',
    'preview.sidebar.sessionWithIndex': 'Session {index}: {title}',
    'preview.sidebar.view': 'View',
    'preview.sidebar.loadingSegments': 'Loading segments...',
    'preview.sidebar.sessionActivitiesLine': 'Activities · Reflection · Assessment',
    'preview.btn.viewPreviousSegment': 'View Previous Segment',

    // Slide component – activity headers and labels
    'slide.activity.journalingTime': 'Journaling Time!',
    'slide.activity.shareWorkTime': 'Share Work Time!',
    'slide.activity.pollTime': 'Poll Time!',
    'slide.activity.discussionTime': 'Discussion Time!',
    'slide.activity.letsTalkAboutIt': "Let's Talk About It",
    'slide.activity.yourSessionScore': 'Your Session Score',
    'slide.activity.journalingPlaceholder': 'Start writing your reflection here...',
    'slide.activity.shareLinkPlaceholder': 'Paste your shareable link here (e.g., Google Drive, Dropbox, etc.)',
    'slide.activity.save': 'Save',
    'slide.activity.submit': 'Submit',
    'slide.assessment.moduleScoreTitle': 'Your Module {module} Assessment Score',
    'slide.assessment.moduleScoreTitleGeneric': 'Your Module Assessment Score',
    'slide.assessment.sessionScoreTitle': 'Your Session Assessment Score',
    'slide.assessment.rubricLevel': 'Level',
    'slide.assessment.rubricDescription': 'Description',
    'slide.assessment.rubricHigh': 'High',
    'slide.assessment.rubricModerate': 'Moderate',
    'slide.assessment.rubricBasic': 'Basic',
    'slide.assessment.rubricLow': 'Low',
    'slide.assessment.rubricHighDesc': 'Your results suggest a strong understanding of this topic. Build on your strengths and try applying your learning in new situations.',
    'slide.assessment.rubricModerateDesc': 'Your results suggest a good understanding of this topic, with some gaps. Review these areas and keep practising what you’ve learned.',
    'slide.assessment.rubricBasicDesc': 'Your results suggest you understand some key ideas. Review the basics and practise to strengthen your knowledge and skills.',
    'slide.assessment.rubricLowDesc': 'Your results suggest that the key ideas need more attention. Revisit the examples and build your understanding step by step.',

    // Slide component – learning content layout labels
    'slide.content.pictureThis': 'Picture this:',
    'slide.content.illustrativeExample': 'Illustrative example',
    'slide.content.learningObjective': 'Learning Objective',
    'slide.content.todaysQuestion': "Today's Question",
    'slide.content.summary': 'Summary',
    'slide.caseStudy.story': 'The Story',
    'slide.caseStudy.meet': 'Meet',
    'slide.caseStudy.problem': 'The Problem',
    'slide.caseStudy.choice': 'The Choice',
    'slide.caseStudy.stopAndThink': 'Stop and Think',
    'slide.caseStudy.risks': 'What Could Go Wrong?',
    'slide.caseStudy.whatHappened': 'What Happened',
    'slide.caseStudy.bigIdea': 'The Big Idea',
    'slide.caseStudy.itsLike': "It's Like…",
    'slide.caseStudy.letsTalk': "Let's Talk",
    'slide.lab.goal': 'Goal',
    'slide.lab.prerequisites': 'Before You Start',
    'slide.lab.tools': 'Tools',
    'slide.lab.steps': 'Steps',
    'slide.lab.expectedResult': 'Expected result',
    'slide.lab.checkpoint': 'Checkpoint',
    'slide.lab.deliverable': 'Deliverable',
    'slide.lab.resources': 'Resources',
    'slide.lab.copy': 'Copy',
    'slide.lab.copied': 'Copied!',
    'slide.lab.timeBox': '{minutes} min',
    'slide.lab.kind.build': 'Build',
    'slide.lab.kind.debug': 'Debug',
    'slide.lab.kind.extend': 'Extend',
    'slide.lab.artifact.prompt': 'Prompt',
    'slide.lab.artifact.code': 'Code',
    'slide.lab.artifact.config': 'Config',
    'slide.lab.artifact.command': 'Command',
    'slide.lab.artifact.template': 'Template',
    'slide.lab.artifact.sample': 'Sample',
    'slide.lab.artifact.checklist': 'Checklist',
    'slide.lab.kind.start': 'Get Started',
    'slide.lab.files': 'Files',
    'slide.lab.troubleshooting': 'If Something Goes Wrong',
    'slide.lab.explainPrefix': 'New',
    'slide.lab.successCriteria': 'You can do this when',
    'slide.lab.predictPrefix': 'Predict first',
    'slide.lab.youWritePrefix': 'You write',
    'slide.lab.showAnswerKey': 'Show the answer key (after your own answers)',
    'slide.lab.revealPrefix': 'Check your prediction (after you answer)',
    'slide.lab.where.terminal': 'Terminal',
    'slide.lab.where.codeEditor': 'Code editor',
    'slide.lab.where.browser': 'Browser',
    'slide.lab.where.app': 'App',
    'slide.lab.where.notebook': 'Notebook',
    'slide.lab.where.phone': 'Phone',
    'slide.lab.where.document': 'Document',
    'slide.lab.where.aiChat': 'AI chat',
    'slide.lab.where.spreadsheet': 'Spreadsheet',
    'slide.lab.where.adminConsole': 'Admin console',
    'slide.map.coreSkill': 'The skill',
    'slide.map.parts': 'Parts of the skill — today marked',
    'slide.map.partsNext': 'Parts of the skill — what comes next',
    'slide.map.scope': 'This session',
    'slide.map.status.today': 'Today',
    'slide.map.status.earlier': 'Done',
    'slide.map.status.later': 'Later',
    'slide.example.inRealSystem': 'In a real system',
    'slide.example.notice': 'What to notice',
    'slide.example.takeaway': 'Takeaway',
    'slide.example.kind.json': 'JSON',
    'slide.example.kind.pseudocode': 'Pseudocode',
    'slide.example.kind.log': 'Log',
    'slide.example.kind.flow': 'Flow',
    'slide.example.kind.table': 'Table',
    'slide.overview.why': 'Why This Matters',
    'slide.overview.coreIdea': 'The Idea in One Sentence',
    'slide.overview.finalResult': 'What You Will Build',
    'slide.overview.howItWorks': 'How It Works',
    'slide.overview.tools': 'Tools You Will Use',
    'slide.overview.youWillNeed': 'What You Will Need',
    'slide.prep.title': 'Before you start',
    'slide.prep.badge': 'Self-study · about {n} min · outside class time',
    'slide.prep.badgeNoTime': 'Self-study · outside class time',
    'slide.prep.search': 'Search: {phrase}',
    'slide.prep.withGrownUp': 'Read this with a grown-up',
    'slide.narrative.oldWorkflow': 'Old Workflow',
    'slide.narrative.before': 'Before',
    'slide.narrative.newWorkflow': 'New Workflow',
    'slide.narrative.after': 'After',
    'slide.narrative.temptingShortcut': 'Tempting Shortcut',
    'slide.narrative.theShortcut': 'The Shortcut',
    'slide.narrative.safetyBuffer': 'Safety Buffer',
    'slide.narrative.thoughtfulResponse': 'Thoughtful Response',
    'slide.narrative.shortcutTaken': 'Shortcut Taken',
    'slide.narrative.catastrophicOutcome': 'Catastrophic Outcome',
    'slide.narrative.downstreamOutcome': 'Downstream Outcome:',
    'slide.spectrum.wrongMindset': 'Wrong Mindset',
    'slide.spectrum.rightMindset': 'Right Mindset',
    'slide.sequence.beforeOperations': '1. Before Operations',
    'slide.sequence.firstSteps': '1. First Steps',
    'slide.sequence.afterOperations': '2. After Operations',
    'slide.sequence.nextActions': '2. Next Actions',
    'slide.modifier.watchOuts': 'Watch-Outs',
    'slide.modifier.whatThisIsNot': 'What this is NOT:',
    'slide.outcome.ifYouDoThisWell': 'If you do this well',
    'slide.outcome.ifYouSkipThis': 'If you skip this',
    'slide.reveal.correct': 'You are correct',
    'slide.reveal.incorrect': 'The correct answer is',
    'slide.reentry.walkedInWith': 'You walked in with',
    'slide.reentry.walkedOutWith': 'You walked out with',
    'slide.reentry.situation': 'Situation',
    'slide.reentry.goBackTo': 'Go back to',
    'slide.recap.titleDefault': 'Putting It All Together',
    'slide.recap.ourBigQuestion': 'Our Big Question:',
    'slide.recap.shortAnswer': 'The short answer:',
    'slide.recap.howWhatYouLearned': 'How what you learned supports this answer:',
    'slide.shareWork.starterScenario': 'Starter Scenario',
    'slide.shareWork.successCriteria': 'Success Criteria',
    'slide.shareWork.tacticalTip': 'Tactical tip:',
    'slide.analysis.howToApply': 'How to apply:',
    'slide.workedExample.takeaway': 'Takeaway:',
    'slide.pledge.iPledge': 'I pledge',
    'slide.video.notSupported': 'Your browser does not support the video tag.',

    // Tutorial
    'tutorial.btn.next': 'Next',
    'tutorial.btn.back': 'Back',
    'tutorial.btn.skip': 'Skip',
    'tutorial.btn.finish': 'Finish',
    'tutorial.checkbox.doNotShowAgain': 'Do not show again',
    'tutorial.step1.title': 'Welcome to DQ Insider',
    'tutorial.step1.content': 'This is your workspace to see the key functions to get started with distributing assessments to your networks.',
    'tutorial.step1.content.partner': 'This is your partner workspace, where you manage school networks and schools, deliver assessments and learning solutions, and track their progress.',
    'tutorial.step1.content.network': 'This is your school network workspace, where you manage your schools and classes, deliver assessments and learning solutions to them, and track their progress.',
    'tutorial.step1.content.school': 'This is your school workspace, where you manage your classes, run assessments and learning solutions, and track how your learners progress.',
    'tutorial.step.mySchools.title': 'My Schools',
    'tutorial.step.mySchools.content.partner': 'Manage your school networks and schools here, and give them access to the solutions you deliver.',
    'tutorial.step.mySchools.content.network': 'Manage your schools here, and give them access to what your network provides.',
    'tutorial.step.pipeline.title': 'Opportunity Pipeline',
    'tutorial.step.pipeline.content': 'Review requests from your school networks and schools here, and suggest learning programs based on their assessment results.',
    'tutorial.step.learningPrograms.title': 'Learning Programs',
    'tutorial.step.learningPrograms.content': 'Manage and create your custom learning programs here.',
    'tutorial.step.learningPrograms.content.network': 'Manage the learning programs available to your network here, and link them to your schools and classes.',
    'tutorial.step.learningPrograms.content.school': 'Manage the learning programs available to your school here, and link them to your classes.',
    'tutorial.step.assessments.title': 'Assessments',
    'tutorial.step.assessments.content': 'View and manage all your assessments here.',
    'tutorial.step.classes.title': 'Classes',
    'tutorial.step.classes.content': 'Manage your classes and students effectively.',
    'tutorial.step.classes.content.network': 'Manage classes across all your schools here, and get your teachers and learners ready for their assessments and learning programs.',
    'tutorial.step.classes.content.school': 'Manage your classes here, and get your teachers and learners ready for their assessments and learning programs.',
    'tutorial.step.profile.title': 'Your Profile',
    'tutorial.step.profile.content': 'Access your settings, change your password, or sign out from here.',

    // Situational / contextual tutorial strings
    // Tutorial A — Program complete, nudge toward Classes
    'tutorial.classesNudge.content': 'Great! Your program is now ready to be linked to your students.\n\nLet\'s link the program.\n\nClick "Your Classes" on the left-side navigation of your dashboard.',

    // Tutorial B — Active chat, build not started (chat banner strings)
    'tutorial.chatNudge.banner.title': 'Not sure where to start?',
    'tutorial.chatNudge.banner.content': 'Continue completing your first program with built-in assessment that you have started - it walks you through the full setup, from publishing the program to distributing it to your learners.',
    'tutorial.chatNudge.banner.btn': 'Finish Creating Your Program',
    'tutorial.chatNudge.banner.dismiss': 'Dismiss',
  },

  'es-ES': {
    // Outline page
    'outline.editModeActive': 'Modo de edición activo',
    'outline.tooltip.saveChanges': 'Guardar cambios',
    'outline.tooltip.editProgramName': 'Editar nombre del programa',
    'outline.tooltip.download': 'Descargar',
    'outline.tooltip.exitEditMode': 'Salir del modo de edición',
    'outline.tooltip.editOutlineContent': 'Editar contenido del esquema',
    'outline.tooltip.edit': 'Editar',
    'outline.tooltip.collapseDetails': 'Contraer para ocultar detalles',
    'outline.tooltip.expandDetails': 'Expandir para ver detalles',
    'outline.tooltip.removeItem': 'Eliminar este elemento',

    'outline.btn.save': 'Guardar',
    'outline.btn.saving': 'Guardando...',
    'outline.btn.cancel': 'Cancelar',
    'outline.btn.startOver': 'Empezar de nuevo',
    'outline.btn.generateProgram': 'Generar programa',
    'outline.btn.goBack': 'Volver',
    'outline.btn.discard': 'Descartar',
    'outline.btn.saveChanges': 'Guardar cambios',
    'outline.btn.yesRemove': 'Sí, eliminar',
    'outline.btn.yesGenerate': 'Sí, generar',

    'outline.title.suffix': 'Esquema del programa',
    'outline.placeholder.enterProgramName': 'Ingresa el nombre del programa',

    'outline.section.learners': 'Participantes',
    'outline.section.programStructure': 'Estructura del programa',
    'outline.section.programLength': 'Duración del programa',
    'outline.section.overview': 'Resumen:',

    'outline.structure.summary': '{modules} Módulo(s) / {units} Unidad(es) / {sessions} Sesión(es)',
    'outline.duration.minutes': '{minutes} minutos',
    'outline.duration.totalMinutes': '({minutes} minutos en total)',
    'outline.label.moduleWithIndex': 'Módulo {index}: {title}',
    'outline.label.unitWithIndex': 'Unidad {index}: {title}',
    'outline.label.sessionWithIndex': 'Sesión {index}: {title}',
    'outline.section.sessionLearningObjectives': 'Objetivos de aprendizaje de la sesión:',

    'outline.educator': 'Educador',
    'outline.learner': 'Aprendiz',
    'outline.ksab.knowledge': 'Conocimientos',
    'outline.ksab.skills': 'Habilidades',
    'outline.ksab.attitudes': 'Actitudes',
    'outline.ksab.behaviours': 'Comportamientos',

    'outline.frameworksAligned': 'Marcos alineados',
    'outline.noFrameworksAligned': 'No hay marcos alineados para este módulo',

    'outline.targetGroup.general': 'Público general',
    'outline.targetGroup.children': 'Niños',
    'outline.targetGroup.teens': 'Adolescentes',
    'outline.targetAge.8_9': 'Edades 8-9',
    'outline.targetAge.10_12': 'Edades 10-12',
    'outline.targetAge.13_14': 'Edades 13-14',
    'outline.targetAge.15_18': 'Edades 15-18',
    'outline.targetAge.allAges': 'Todas las edades',
    'outline.targetAge.workforce': 'Fuerza laboral',
    'outline.targetTier.T1': 'Primaria menor (Edades 7–9)',
    'outline.targetTier.T2': 'Primaria mayor (Edades 10–12)',
    'outline.targetTier.T3': 'Secundaria baja (Edades 13–14)',
    'outline.targetTier.T4': 'Secundaria alta (Edades 15–17)',
    'outline.targetTier.T5': 'Educación superior (Edades 18–22)',
    'outline.targetTier.T6': 'Público general (Todas las edades)',
    'outline.targetTier.T7': 'Fuerza laboral',

    'outline.toast.editNotAvailableEnglish': 'La edición no está disponible para inglés. Selecciona otro idioma.',
    'outline.toast.failedOpenPdf': 'No se pudo abrir el PDF',
    'outline.toast.failedSaveOutline': 'No se pudo guardar el esquema',
    'outline.toast.failedRemoval': 'No se pudo completar la eliminación',

    'outline.dialog.removeItem.title': '¿Seguro que quieres eliminar este/esta {type}?',
    'outline.dialog.removeProgram.html': '¿Seguro que quieres eliminar este programa?<br/>Esta acción no se puede deshacer.',
    'outline.dialog.lastItem.title.program': 'Advertencia: eliminar programa actual',
    'outline.dialog.lastItem.title.module': 'Advertencia: eliminar módulo',
    'outline.dialog.lastItem.title.unit': 'Advertencia: eliminar unidad',
    'outline.dialog.lastItem.body.program.html':
      'Este es el/la último/a {type} del programa.<br/>Al eliminarlo/a se <strong>eliminará todo el programa actual</strong> y se creará un nuevo programa.<br/>¿Seguro que deseas continuar? Esta acción no se puede deshacer.',
    'outline.dialog.lastItem.body.module.html':
      'Este es el/la último/a {type} de este módulo.<br/>Al eliminar este/esta {type} también se <strong>eliminará todo el módulo</strong>.<br/>¿Seguro que deseas continuar? Esta acción no se puede deshacer.',
    'outline.dialog.lastItem.body.unit.html':
      'Este es el/la último/a {type} de esta unidad.<br/>Al eliminar este/esta {type} también se <strong>eliminará toda la unidad</strong>.<br/>¿Seguro que deseas continuar? Esta acción no se puede deshacer.',
    'outline.dialog.lastItem.confirm.program': 'Sí, eliminar programa',
    'outline.dialog.lastItem.confirm.module': 'Sí, eliminar módulo',
    'outline.dialog.lastItem.confirm.unit': 'Sí, eliminar unidad',

    'outline.dialog.generate.body.html':
      '¿Seguro que deseas generar este programa con <b>{count} sesión(es)?</b><br/>Una vez creado, no podrás hacer cambios y se te cobrará por las sesiones generadas.',

    'outline.dialog.unsaved.title': 'Cambios sin guardar',
    'outline.dialog.unsaved.body': 'Tienes cambios sin guardar. Guárdalos ahora o se descartarán.',

    // Duration formatting
    'duration.minutes': 'minutos',
    'duration.hour': 'hora',
    'duration.hours': 'horas',
    'duration.and': 'y',
    
    // Outline PDF/HTML documents
    'outlineDoc.title.prefix': 'Esquema del programa para',
    'outlineDoc.viewType.educator': 'Vista del educador',
    'outlineDoc.viewType.learner': 'Vista del aprendiz',
    'outlineDoc.meta.learners': 'Participantes:',
    'outlineDoc.meta.programStructure': 'Estructura del programa:',
    'outlineDoc.meta.programLength': 'Duración del programa:',
    'outlineDoc.meta.notSpecified': 'No especificado',
    'outlineDoc.structure.modules': 'Módulo(s)',
    'outlineDoc.structure.units': 'Unidad(es)',
    'outlineDoc.structure.sessions': 'Sesión(es)',
    'outlineDoc.section.overview': 'Resumen:',
    'outlineDoc.ksab.label': 'KSAB:',
    'outlineDoc.ksab.knowledge': 'Conocimientos',
    'outlineDoc.ksab.skills': 'Habilidades',
    'outlineDoc.ksab.attitudes': 'Actitudes',
    'outlineDoc.ksab.behaviours': 'Comportamientos',
    'outlineDoc.dqCode.label': 'Código(s) DQ:',
    'outlineDoc.module.label': 'Módulo',
    'outlineDoc.unit.label': 'Unidad',
    'outlineDoc.session.label': 'Sesión',
    'outlineDoc.session.learningObjectives': 'Objetivos de aprendizaje de la sesión:',
    'outlineDoc.frameworksAligned': 'Marcos alineados:',
    'outlineDoc.noFrameworks': 'No hay marcos alineados para este programa',
    'outlineDoc.footer.copyright': 'DQ LAB Pte Ltd. Todos los derechos reservados. Powered by DQ',
    'outlineDoc.footer.trademark': 'es una marca registrada de DQ LAB Pte Ltd.',

    // Teaching Plan PDF/HTML documents
    'teachingPlan.title.suffix': 'Plan de enseñanza para educadores',
    'teachingPlan.meta.learners': 'Participantes:',
    'teachingPlan.meta.programStructure': 'Estructura del programa:',
    'teachingPlan.meta.programLength': 'Duración del programa:',
    'teachingPlan.meta.notSpecified': 'No especificado',
    'teachingPlan.structure.modules': 'Módulo(s)',
    'teachingPlan.structure.units': 'Unidad(es)',
    'teachingPlan.structure.sessions': 'Sesión(es)',
    'teachingPlan.section.overview': 'Resumen',
    'teachingPlan.section.preparingClass': 'Preparando tu clase',
    'teachingPlan.prep.beforeBeginning': 'Antes de comenzar el programa:',
    'teachingPlan.prep.internetAccess': 'Asegúrate de que tu aula tenga {bold1} y {bold2} (computadoras o tabletas).',
    'teachingPlan.prep.internetAccessBold1': 'acceso a internet',
    'teachingPlan.prep.internetAccessBold2': 'dispositivos digitales',
    'teachingPlan.prep.studentAccounts': 'Confirma que todos los estudiantes tengan cuentas y puedan iniciar sesión en {link}.',
    'teachingPlan.prep.studentAccountsLink': 'www.dqforall.com',
    'teachingPlan.prep.websiteBlocked': 'Si el sitio web está bloqueado, pide a tu {bold} que lo incluya en la lista blanca o lo desbloquee.',
    'teachingPlan.prep.websiteBlockedBold': 'administrador del sistema',
    'teachingPlan.prep.headphones': 'Anima a los estudiantes a traer {bold} (algunas actividades incluyen video o audio).',
    'teachingPlan.prep.headphonesBold': 'auriculares',
    'teachingPlan.module.label': 'Módulo',
    'teachingPlan.unit.label': 'Unidad',
    'teachingPlan.session.label': 'Sesión',
    'teachingPlan.session.untitled': 'Sesión sin título',
    'teachingPlan.session.learningObjectives': 'Objetivos de aprendizaje de la sesión',
    'teachingPlan.table.estimatedTime': 'Tiempo estimado',
    'teachingPlan.table.segment': 'Segmento',
    'teachingPlan.table.activities': 'Actividades',
    'teachingPlan.table.description': 'Descripción',
    'teachingPlan.table.minutes': 'min',
    'teachingPlan.segment.introduction': 'Introducción',
    'teachingPlan.segment.introduction.activity1': 'Ver diapositivas de contenido',
    'teachingPlan.segment.introduction.activity2': 'Ver video de introducción',
    'teachingPlan.segment.introduction.description': 'Los estudiantes son introducidos al tema de la sesión y los objetivos de aprendizaje.',
    'teachingPlan.segment.preAssessment': 'Evaluación previa',
    'teachingPlan.segment.preAssessment.activity1': 'Completar preguntas de evaluación',
    'teachingPlan.segment.preAssessment.activity2': 'Autoevaluación',
    'teachingPlan.segment.preAssessment.description': 'Los estudiantes completan una evaluación previa para medir su conocimiento existente sobre el tema.',
    'teachingPlan.segment.learningObjective': 'Objetivo de aprendizaje',
    'teachingPlan.segment.slo.activity1': 'Actividades interactivas',
    'teachingPlan.segment.slo.activity2': 'Práctica guiada',
    'teachingPlan.segment.slo.activity3': 'Responder encuestas',
    'teachingPlan.segment.slo.activity4': 'Aplicar conceptos',
    'teachingPlan.segment.slo.description': 'Los estudiantes interactúan con el contenido de aprendizaje a través de actividades interactivas.',
    'teachingPlan.segment.mainContent': 'Contenido principal',
    'teachingPlan.segment.mainContent.activity1': 'Actividades de aprendizaje interactivas',
    'teachingPlan.segment.mainContent.activity2': 'Exploración guiada',
    'teachingPlan.segment.mainContent.activity3': 'Discusiones grupales',
    'teachingPlan.segment.mainContent.description': 'Los estudiantes interactúan con el contenido de aprendizaje principal a través de actividades interactivas y discusiones.',
    'teachingPlan.segment.reflection': 'Reflexión',
    'teachingPlan.segment.reflection.activity1': 'Reflexión personal',
    'teachingPlan.segment.reflection.activity2': 'Responder preguntas de reflexión',
    'teachingPlan.segment.reflection.activity3': 'Compartir ideas',
    'teachingPlan.segment.reflection.description': 'Los estudiantes reflexionan sobre su aprendizaje y comparten conclusiones clave con sus compañeros.',
    'teachingPlan.segment.postAssessment': 'Evaluación posterior',
    'teachingPlan.segment.postAssessment.activity1': 'Completar preguntas de evaluación',
    'teachingPlan.segment.postAssessment.activity2': 'Revisar respuestas',
    'teachingPlan.segment.postAssessment.description': 'Los estudiantes completan una evaluación posterior para demostrar su comprensión de los conceptos aprendidos.',
    'teachingPlan.segment.recap': 'Recapitulación',
    'teachingPlan.segment.recap.activity1': 'Revisar conceptos clave',
    'teachingPlan.segment.recap.activity2': 'Sesión de preguntas y respuestas',
    'teachingPlan.segment.recap.activity3': 'Resumen',
    'teachingPlan.segment.recap.description': 'Los puntos clave de aprendizaje se revisan y refuerzan para asegurar la comprensión.',
    'teachingPlan.section.teacherNotes': 'Notas del profesor',
    'teachingPlan.notes.note1': 'Mantén un ambiente de clase abierto y curioso.',
    'teachingPlan.notes.note2': 'Refuerza las lecciones continuamente verificando con los estudiantes después de cada recapitulación de sesión usando discusiones grupales en vivo o actividades de reflexión rápidas.',
    'teachingPlan.notes.note3': 'Rastrea el progreso y el impacto a través de tu {bold}.',
    'teachingPlan.notes.note3Bold': 'Panel escolar Powered by DQ',
    'teachingPlan.footer.copyright': 'DQ LAB Pte Ltd. Todos los derechos reservados. Powered by DQ',
    'teachingPlan.footer.trademark': 'es una marca registrada de DQ LAB Pte Ltd.',

    // Preview page
    'preview.editModeActive': 'Modo de edición activo',
    'preview.preAssessment': 'Evaluación previa',
    'preview.postAssessment': 'Evaluación posterior',
    'preview.deck.download': 'Descargar HTML',
    'preview.deck.preparing': 'Preparando HTML…',
    'preview.deck.failed': 'No se pudieron preparar las diapositivas para descargar. Inténtalo de nuevo.',
    'preview.deck.noVideo': 'Video no disponible',
    'preview.deck.slideCount': '{count} diapositivas',
    'preview.deck.noSlides': 'Aún no hay diapositivas',
    'preview.assessment.quickTestFirst': '¡Hagamos una prueba rápida primero!',
    'preview.assessment.testKnowledgeSkills': '¡Pongamos a prueba tus conocimientos y habilidades!',
    'preview.assessment.introAlt': 'Introducción de la evaluación',
    'preview.assessment.introTitle': 'Introducción de la evaluación',
    'preview.assessment.noQuestions': 'No hay preguntas disponibles.',
    'preview.tooltip.exitEditMode': 'Salir del modo de edición',
    'preview.tooltip.editNotAvailableEnglish': 'La edición no está disponible para contenido solo en inglés',
    'preview.tooltip.editToggleLanguage': 'La edición solo está disponible en versiones en otros idiomas. Cambia al otro idioma para editar.',
    'preview.tooltip.editSlideContent': 'Editar contenido de la diapositiva',
    'preview.btn.viewNextSession': 'Ver siguiente sesión',
    'preview.btn.viewNextSegment': 'Ver siguiente segmento',
    'preview.btn.hide': 'Ocultar',
    'preview.btn.unhide': 'Mostrar',
    'preview.tts.voice': 'Voz',
    'preview.tts.noVoices': 'Aún no hay voces disponibles',
    'preview.tts.rate': 'Velocidad',
    'preview.tts.pitch': 'Tono',
    'preview.tts.volume': 'Volumen',
    'preview.segment.introduction': 'Introducción',
    'preview.segment.reflection': 'Reflexión',
    'preview.segment.recap': 'Resumen',
    'preview.segment.sessionScore': 'Puntuación de la sesión',
    'preview.toast.failedSave': 'No se pudieron guardar los cambios. Inténtalo de nuevo.',
    'preview.toast.ttsBrowser': 'El texto a voz parece tener problemas con tu navegador. Actualiza la versión o prueba otro navegador.',
    'preview.toast.editNotAvailableEnglish': 'La edición no está disponible para contenido solo en inglés.',
    'preview.toast.editToggleLanguage': 'La edición solo está disponible en versiones en otros idiomas. Cambia para ver el contenido en otro idioma.',
    'preview.toast.outlineNotReady': '¡El esquema del programa aún no está listo!',
    'preview.toast.sessionNotAvailable': 'La sesión "{title}" no está disponible.',
    'preview.toast.sessionGenerating': 'La sesión "{title}" se está generando. Espera, por favor.',
    'preview.selectSession': 'Selecciona una sesión del menú para ver el contenido',
    'preview.assessmentModal.hideConfirm': 'Ocultar la evaluación eliminará las evaluaciones previa y posterior para tus estudiantes en todas las sesiones de este módulo.<br/>¿Seguro que quieres continuar?',
    'preview.assessmentModal.unhideConfirm': 'Al mostrar esta evaluación, las evaluaciones previa y posterior de todas las sesiones de este módulo volverán a ser visibles para tus estudiantes.<br/>¿Seguro que quieres continuar?',
    'preview.error.slideLayoutNotFound': 'Error: Diseño de diapositiva no encontrado',
    'preview.loadingSlides': 'Cargando diapositivas...',
    'preview.sidebar.moduleWithIndex': 'Módulo {index}: {title}',
    'preview.sidebar.unitWithIndex': 'Unidad {index}: {title}',
    'preview.sidebar.sessionWithIndex': 'Sesión {index}: {title}',
    'preview.sidebar.view': 'Ver',
    'preview.sidebar.loadingSegments': 'Cargando segmentos...',
    'preview.sidebar.sessionActivitiesLine': 'Actividades · Reflexión · Evaluación',
    'preview.btn.viewPreviousSegment': 'Ver segmento anterior',
    'slide.activity.journalingTime': '¡Momento de reflexión!',
    'slide.activity.shareWorkTime': '¡Momento de compartir!',
    'slide.activity.pollTime': '¡Encuesta!',
    'slide.activity.discussionTime': '¡Momento de debate!',
    'slide.activity.letsTalkAboutIt': 'Hablemos de ello',
    'slide.activity.yourSessionScore': 'Tu puntuación de la sesión',
    'slide.activity.journalingPlaceholder': 'Escribe aquí tu reflexión...',
    'slide.activity.shareLinkPlaceholder': 'Pega aquí tu enlace (p. ej. Google Drive, Dropbox, etc.)',
    'slide.activity.save': 'Guardar',
    'slide.activity.submit': 'Enviar',
    'slide.assessment.moduleScoreTitle': 'Puntuación de la evaluación del Módulo {module}',
    'slide.assessment.moduleScoreTitleGeneric': 'Puntuación de la evaluación del módulo',
    'slide.assessment.sessionScoreTitle': 'Puntuación de evaluación de la sesión',
    'slide.assessment.rubricLevel': 'Nivel',
    'slide.assessment.rubricDescription': 'Descripción',
    'slide.assessment.rubricHigh': 'Alto',
    'slide.assessment.rubricModerate': 'Moderado',
    'slide.assessment.rubricBasic': 'Básico',
    'slide.assessment.rubricLow': 'Bajo',
    'slide.assessment.rubricHighDesc': 'Tus resultados indican una sólida comprensión de este tema. Aprovecha tus fortalezas e intenta aplicar lo aprendido en situaciones nuevas.',
    'slide.assessment.rubricModerateDesc': 'Tus resultados indican una buena comprensión de este tema, con algunas lagunas. Repasa esas áreas y sigue practicando lo que has aprendido.',
    'slide.assessment.rubricBasicDesc': 'Tus resultados indican que comprendes algunas ideas clave. Repasa lo básico y practica para reforzar tus conocimientos y habilidades.',
    'slide.assessment.rubricLowDesc': 'Tus resultados indican que las ideas clave necesitan más atención. Vuelve a revisar los ejemplos y desarrolla tu comprensión paso a paso.',

    // Slide component – learning content layout labels
    'slide.content.pictureThis': 'Imagínate esto:',
    'slide.content.illustrativeExample': 'Ejemplo ilustrativo',
    'slide.content.learningObjective': 'Objetivo de aprendizaje',
    'slide.content.todaysQuestion': 'La pregunta de hoy',
    'slide.content.summary': 'Resumen',
    'slide.caseStudy.story': 'La historia',
    'slide.caseStudy.meet': 'Conoce a',
    'slide.caseStudy.problem': 'El problema',
    'slide.caseStudy.choice': 'La decisión',
    'slide.caseStudy.stopAndThink': 'Para y piensa',
    'slide.caseStudy.risks': '¿Qué podría salir mal?',
    'slide.caseStudy.whatHappened': 'Qué pasó',
    'slide.caseStudy.bigIdea': 'La gran idea',
    'slide.caseStudy.itsLike': 'Es como…',
    'slide.caseStudy.letsTalk': 'Hablemos',
    'slide.lab.goal': 'Objetivo',
    'slide.lab.prerequisites': 'Antes de empezar',
    'slide.lab.tools': 'Herramientas',
    'slide.lab.steps': 'Pasos',
    'slide.lab.expectedResult': 'Resultado esperado',
    'slide.lab.checkpoint': 'Punto de control',
    'slide.lab.deliverable': 'Entregable',
    'slide.lab.resources': 'Recursos',
    'slide.lab.copy': 'Copiar',
    'slide.lab.copied': '¡Copiado!',
    'slide.lab.timeBox': '{minutes} min',
    'slide.lab.kind.build': 'Construir',
    'slide.lab.kind.debug': 'Depurar',
    'slide.lab.kind.extend': 'Ampliar',
    'slide.lab.artifact.prompt': 'Prompt',
    'slide.lab.artifact.code': 'Código',
    'slide.lab.artifact.config': 'Configuración',
    'slide.lab.artifact.command': 'Comando',
    'slide.lab.artifact.template': 'Plantilla',
    'slide.lab.artifact.sample': 'Ejemplo',
    'slide.lab.artifact.checklist': 'Lista de verificación',
    'slide.lab.kind.start': 'Primeros pasos',
    'slide.lab.files': 'Archivos',
    'slide.lab.troubleshooting': 'Si algo sale mal',
    'slide.lab.explainPrefix': 'Nuevo',
    'slide.lab.successCriteria': 'Lo has logrado cuando',
    'slide.lab.predictPrefix': 'Predice primero',
    'slide.lab.youWritePrefix': 'Escribes tú',
    'slide.lab.showAnswerKey': 'Mostrar las respuestas (después de las tuyas)',
    'slide.lab.revealPrefix': 'Comprueba tu predicción (después de responder)',
    'slide.lab.where.terminal': 'Terminal',
    'slide.lab.where.codeEditor': 'Editor de código',
    'slide.lab.where.browser': 'Navegador',
    'slide.lab.where.app': 'Aplicación',
    'slide.lab.where.notebook': 'Cuaderno',
    'slide.lab.where.phone': 'Teléfono',
    'slide.lab.where.document': 'Documento',
    'slide.lab.where.aiChat': 'Chat de IA',
    'slide.lab.where.spreadsheet': 'Hoja de cálculo',
    'slide.lab.where.adminConsole': 'Consola de administración',
    'slide.map.coreSkill': 'La habilidad',
    'slide.map.parts': 'Partes de la habilidad: las de hoy están marcadas',
    'slide.map.partsNext': 'Partes de la habilidad: lo que sigue',
    'slide.map.scope': 'Esta sesión',
    'slide.map.status.today': 'Hoy',
    'slide.map.status.earlier': 'Hecho',
    'slide.map.status.later': 'Después',
    'slide.example.inRealSystem': 'En un sistema real',
    'slide.example.notice': 'Qué observar',
    'slide.example.takeaway': 'Conclusión',
    'slide.example.kind.json': 'JSON',
    'slide.example.kind.pseudocode': 'Pseudocódigo',
    'slide.example.kind.log': 'Registro',
    'slide.example.kind.flow': 'Flujo',
    'slide.example.kind.table': 'Tabla',
    'slide.overview.why': 'Por qué importa',
    'slide.overview.coreIdea': 'La idea en una frase',
    'slide.overview.finalResult': 'Lo que vas a construir',
    'slide.overview.howItWorks': 'Cómo funciona',
    'slide.overview.tools': 'Herramientas que usarás',
    'slide.overview.youWillNeed': 'Lo que necesitarás',
    'slide.prep.title': 'Antes de empezar',
    'slide.prep.badge': 'Estudio autónomo · unos {n} min · fuera del horario de clase',
    'slide.prep.badgeNoTime': 'Estudio autónomo · fuera del horario de clase',
    'slide.prep.search': 'Busca: {phrase}',
    'slide.prep.withGrownUp': 'Léelo con una persona adulta',
    'slide.narrative.oldWorkflow': 'Flujo de trabajo anterior',
    'slide.narrative.before': 'Antes',
    'slide.narrative.newWorkflow': 'Nuevo flujo de trabajo',
    'slide.narrative.after': 'Después',
    'slide.narrative.temptingShortcut': 'Atajo tentador',
    'slide.narrative.theShortcut': 'El atajo',
    'slide.narrative.safetyBuffer': 'Margen de seguridad',
    'slide.narrative.thoughtfulResponse': 'Respuesta reflexiva',
    'slide.narrative.shortcutTaken': 'Atajo tomado',
    'slide.narrative.catastrophicOutcome': 'Resultado catastrófico',
    'slide.narrative.downstreamOutcome': 'Resultado posterior:',
    'slide.spectrum.wrongMindset': 'Mentalidad errónea',
    'slide.spectrum.rightMindset': 'Mentalidad correcta',
    'slide.sequence.beforeOperations': '1. Antes de las operaciones',
    'slide.sequence.firstSteps': '1. Primeros pasos',
    'slide.sequence.afterOperations': '2. Después de las operaciones',
    'slide.sequence.nextActions': '2. Siguientes acciones',
    'slide.modifier.watchOuts': 'Puntos de atención',
    'slide.modifier.whatThisIsNot': 'Lo que esto NO es:',
    'slide.outcome.ifYouDoThisWell': 'Si lo haces bien',
    'slide.outcome.ifYouSkipThis': 'Si omites esto',
    'slide.reveal.correct': '¡Correcto!',
    'slide.reveal.incorrect': 'La respuesta correcta es',
    'slide.reentry.walkedInWith': 'Llegaste con',
    'slide.reentry.walkedOutWith': 'Te vas con',
    'slide.reentry.situation': 'Situación',
    'slide.reentry.goBackTo': 'Volver a',
    'slide.recap.titleDefault': 'Integrándolo todo',
    'slide.recap.ourBigQuestion': 'Nuestra gran pregunta:',
    'slide.recap.shortAnswer': 'La respuesta breve:',
    'slide.recap.howWhatYouLearned': 'Cómo lo aprendido respalda esta respuesta:',
    'slide.shareWork.starterScenario': 'Escenario inicial',
    'slide.shareWork.successCriteria': 'Criterios de éxito',
    'slide.shareWork.tacticalTip': 'Consejo táctico:',
    'slide.analysis.howToApply': 'Cómo aplicar:',
    'slide.workedExample.takeaway': 'Conclusión:',
    'slide.pledge.iPledge': 'Me comprometo',
    'slide.video.notSupported': 'Tu navegador no admite la etiqueta de vídeo.',
  },

  'ja-JP': {
    // Duration formatting
    'duration.minutes': '分',
    'duration.hour': '時間',
    'duration.hours': '時間',
    'duration.and': 'と',
    
    // Outline page
    'outline.editModeActive': '編集モード有効',
    'outline.tooltip.saveChanges': '変更を保存',
    'outline.tooltip.editProgramName': 'プログラム名を編集',
    'outline.tooltip.download': 'ダウンロード',
    'outline.tooltip.exitEditMode': '編集モードを終了',
    'outline.tooltip.editOutlineContent': 'アウトライン内容を編集',
    'outline.tooltip.edit': '編集',
    'outline.tooltip.collapseDetails': '折りたたんで詳細を非表示',
    'outline.tooltip.expandDetails': '展開して詳細を表示',
    'outline.tooltip.removeItem': 'この項目を削除',

    'outline.btn.save': '保存',
    'outline.btn.saving': '保存中...',
    'outline.btn.cancel': 'キャンセル',
    'outline.btn.startOver': 'やり直す',
    'outline.btn.generateProgram': 'プログラムを生成',
    'outline.btn.goBack': '戻る',
    'outline.btn.discard': '破棄',
    'outline.btn.saveChanges': '変更を保存',
    'outline.btn.yesRemove': 'はい、削除',
    'outline.btn.yesGenerate': 'はい、生成',

    'outline.title.suffix': 'プログラムアウトライン',
    'outline.placeholder.enterProgramName': 'プログラム名を入力',

    'outline.section.learners': '学習者',
    'outline.section.programStructure': 'プログラム構成',
    'outline.section.programLength': '所要時間',
    'outline.section.overview': '概要:',

    'outline.structure.summary': '{modules} モジュール / {units} ユニット / {sessions} セッション',
    'outline.duration.minutes': '{minutes} 分',
    'outline.duration.totalMinutes': '（合計 {minutes} 分）',
    'outline.label.moduleWithIndex': 'モジュール {index}: {title}',
    'outline.label.unitWithIndex': 'ユニット {index}: {title}',
    'outline.label.sessionWithIndex': 'セッション {index}: {title}',
    'outline.section.sessionLearningObjectives': 'セッションの学習目標:',

    'outline.educator': '教育者',
    'outline.learner': '学習者',
    'outline.ksab.knowledge': '知識',
    'outline.ksab.skills': 'スキル',
    'outline.ksab.attitudes': '態度',
    'outline.ksab.behaviours': '行動',

    'outline.frameworksAligned': '整合フレームワーク',
    'outline.noFrameworksAligned': 'このモジュールに整合するフレームワークはありません',

    'outline.targetGroup.general': '一般',
    'outline.targetGroup.children': '子ども',
    'outline.targetGroup.teens': 'ティーン',
    'outline.targetAge.8_9': '8〜9歳',
    'outline.targetAge.10_12': '10〜12歳',
    'outline.targetAge.13_14': '13〜14歳',
    'outline.targetAge.15_18': '15〜18歳',
    'outline.targetAge.allAges': '全年齢',
    'outline.targetAge.workforce': '社会人',
    'outline.targetTier.T1': '小学校低学年 (7〜9歳)',
    'outline.targetTier.T2': '小学校高学年 (10〜12歳)',
    'outline.targetTier.T3': '中学校 (13〜14歳)',
    'outline.targetTier.T4': '高校 (15〜17歳)',
    'outline.targetTier.T5': '高等教育・大学 (18〜22歳)',
    'outline.targetTier.T6': '一般 (全年齢)',
    'outline.targetTier.T7': '社会人',

    'outline.toast.editNotAvailableEnglish': '英語では編集できません。別の言語を選択してください。',
    'outline.toast.failedOpenPdf': 'PDF を開けませんでした',
    'outline.toast.failedSaveOutline': 'アウトラインの保存に失敗しました',
    'outline.toast.failedRemoval': '削除処理に失敗しました',

    'outline.dialog.removeItem.title': 'この {type} を削除してもよろしいですか？',
    'outline.dialog.removeProgram.html': 'このプログラムを削除してもよろしいですか？<br/>この操作は元に戻せません。',
    'outline.dialog.lastItem.title.program': '警告: 現在のプログラムを削除',
    'outline.dialog.lastItem.title.module': '警告: モジュールを削除',
    'outline.dialog.lastItem.title.unit': '警告: ユニットを削除',
    'outline.dialog.lastItem.body.program.html':
      'これはプログラム内の最後の {type} です。<br/>これを削除すると <strong>現在のプログラム全体が削除</strong> され、新しいプログラムが作成されます。<br/>続行しますか？この操作は元に戻せません。',
    'outline.dialog.lastItem.body.module.html':
      'これはこのモジュール内の最後の {type} です。<br/>この {type} を削除すると <strong>モジュール全体も削除</strong> されます。<br/>続行しますか？この操作は元に戻せません。',
    'outline.dialog.lastItem.body.unit.html':
      'これはこのユニット内の最後の {type} です。<br/>この {type} を削除すると <strong>ユニット全体も削除</strong> されます。<br/>続行しますか？この操作は元に戻せません。',
    'outline.dialog.lastItem.confirm.program': 'はい、プログラムを削除',
    'outline.dialog.lastItem.confirm.module': 'はい、モジュールを削除',
    'outline.dialog.lastItem.confirm.unit': 'はい、ユニットを削除',

    'outline.dialog.generate.body.html':
      'このプログラムを <b>{count} セッション</b> で生成しますか？<br/>作成後は変更できず、生成されたセッション分が課金されます。',

    'outline.dialog.unsaved.title': '未保存の変更',
    'outline.dialog.unsaved.body': '未保存の変更があります。今保存しないと破棄されます。',

    // Outline PDF/HTML documents
    'outlineDoc.title.prefix': 'プログラム概要',
    'outlineDoc.viewType.educator': '教育者ビュー',
    'outlineDoc.viewType.learner': '学習者ビュー',
    'outlineDoc.meta.learners': '学習者:',
    'outlineDoc.meta.programStructure': 'プログラム構成:',
    'outlineDoc.meta.programLength': 'プログラム期間:',
    'outlineDoc.meta.notSpecified': '指定なし',
    'outlineDoc.structure.modules': 'モジュール',
    'outlineDoc.structure.units': 'ユニット',
    'outlineDoc.structure.sessions': 'セッション',
    'outlineDoc.section.overview': '概要:',
    'outlineDoc.ksab.label': 'KSAB:',
    'outlineDoc.ksab.knowledge': '知識',
    'outlineDoc.ksab.skills': 'スキル',
    'outlineDoc.ksab.attitudes': '態度',
    'outlineDoc.ksab.behaviours': '行動',
    'outlineDoc.dqCode.label': 'DQコード:',
    'outlineDoc.module.label': 'モジュール',
    'outlineDoc.unit.label': 'ユニット',
    'outlineDoc.session.label': 'セッション',
    'outlineDoc.session.learningObjectives': 'セッション学習目標:',
    'outlineDoc.frameworksAligned': '整合されたフレームワーク:',
    'outlineDoc.noFrameworks': 'このプログラムに整合されたフレームワークはありません',
    'outlineDoc.footer.copyright': 'DQ LAB Pte Ltd. 無断複写・転載を禁じます。Powered by DQ',
    'outlineDoc.footer.trademark': 'はDQ LAB Pte Ltd.の登録商標です。',

    // Teaching Plan PDF/HTML documents
    'teachingPlan.title.suffix': '教育者指導計画',
    'teachingPlan.meta.learners': '学習者:',
    'teachingPlan.meta.programStructure': 'プログラム構成:',
    'teachingPlan.meta.programLength': 'プログラム期間:',
    'teachingPlan.meta.notSpecified': '指定なし',
    'teachingPlan.structure.modules': 'モジュール',
    'teachingPlan.structure.units': 'ユニット',
    'teachingPlan.structure.sessions': 'セッション',
    'teachingPlan.section.overview': '概要',
    'teachingPlan.section.preparingClass': 'クラスの準備',
    'teachingPlan.prep.beforeBeginning': 'プログラム開始前に:',
    'teachingPlan.prep.internetAccess': '教室に{bold1}と{bold2}（コンピューターまたはタブレット）があることを確認してください。',
    'teachingPlan.prep.internetAccessBold1': 'インターネット接続',
    'teachingPlan.prep.internetAccessBold2': 'デジタルデバイス',
    'teachingPlan.prep.studentAccounts': 'すべての生徒がアカウントを持ち、{link}にログインできることを確認してください。',
    'teachingPlan.prep.studentAccountsLink': 'www.dqforall.com',
    'teachingPlan.prep.websiteBlocked': 'ウェブサイトがブロックされている場合は、{bold}にホワイトリストへの追加またはブロック解除を依頼してください。',
    'teachingPlan.prep.websiteBlockedBold': 'システム管理者',
    'teachingPlan.prep.headphones': '生徒に{bold}の持参を推奨してください（一部のアクティビティには動画や音声が含まれます）。',
    'teachingPlan.prep.headphonesBold': 'ヘッドホン',
    'teachingPlan.module.label': 'モジュール',
    'teachingPlan.unit.label': 'ユニット',
    'teachingPlan.session.label': 'セッション',
    'teachingPlan.session.untitled': '無題のセッション',
    'teachingPlan.session.learningObjectives': 'セッション学習目標',
    'teachingPlan.table.estimatedTime': '推定時間',
    'teachingPlan.table.segment': 'セグメント',
    'teachingPlan.table.activities': 'アクティビティ',
    'teachingPlan.table.description': '説明',
    'teachingPlan.table.minutes': '分',
    'teachingPlan.segment.introduction': '導入',
    'teachingPlan.segment.introduction.activity1': 'コンテンツスライドを見る',
    'teachingPlan.segment.introduction.activity2': '導入動画を見る',
    'teachingPlan.segment.introduction.description': '生徒はセッションのトピックと学習目標を紹介されます。',
    'teachingPlan.segment.preAssessment': '事前評価',
    'teachingPlan.segment.preAssessment.activity1': '評価問題に答える',
    'teachingPlan.segment.preAssessment.activity2': '自己評価',
    'teachingPlan.segment.preAssessment.description': '生徒は事前評価を完了し、トピックに関する既存の知識を測定します。',
    'teachingPlan.segment.learningObjective': '学習目標',
    'teachingPlan.segment.slo.activity1': 'インタラクティブなアクティビティ',
    'teachingPlan.segment.slo.activity2': 'ガイド付き練習',
    'teachingPlan.segment.slo.activity3': 'アンケートに答える',
    'teachingPlan.segment.slo.activity4': '概念を適用する',
    'teachingPlan.segment.slo.description': '生徒はインタラクティブなアクティビティを通じて学習コンテンツに取り組みます。',
    'teachingPlan.segment.mainContent': 'メインコンテンツ',
    'teachingPlan.segment.mainContent.activity1': 'インタラクティブな学習アクティビティ',
    'teachingPlan.segment.mainContent.activity2': 'ガイド付き探索',
    'teachingPlan.segment.mainContent.activity3': 'グループディスカッション',
    'teachingPlan.segment.mainContent.description': '生徒はインタラクティブなアクティビティとディスカッションを通じて主要な学習コンテンツに取り組みます。',
    'teachingPlan.segment.reflection': '振り返り',
    'teachingPlan.segment.reflection.activity1': '個人的な振り返り',
    'teachingPlan.segment.reflection.activity2': '振り返りの質問に答える',
    'teachingPlan.segment.reflection.activity3': '洞察を共有する',
    'teachingPlan.segment.reflection.description': '生徒は学習を振り返り、重要なポイントを仲間と共有します。',
    'teachingPlan.segment.postAssessment': '事後評価',
    'teachingPlan.segment.postAssessment.activity1': '評価問題に答える',
    'teachingPlan.segment.postAssessment.activity2': '回答を確認する',
    'teachingPlan.segment.postAssessment.description': '生徒は事後評価を完了し、学習した概念の理解を示します。',
    'teachingPlan.segment.recap': 'まとめ',
    'teachingPlan.segment.recap.activity1': '主要な概念を復習する',
    'teachingPlan.segment.recap.activity2': '質疑応答セッション',
    'teachingPlan.segment.recap.activity3': '要約',
    'teachingPlan.segment.recap.description': '主要な学習ポイントが復習され、理解を確実にするために強化されます。',
    'teachingPlan.section.teacherNotes': '教師のメモ',
    'teachingPlan.notes.note1': 'オープンで好奇心旺盛な教室環境を維持してください。',
    'teachingPlan.notes.note2': '各セッションのまとめ後にライブグループディスカッションまたは簡単な振り返りアクティビティを使用して生徒と確認することで、レッスンを継続的に強化してください。',
    'teachingPlan.notes.note3': '{bold}を通じて進捗と影響を追跡してください。',
    'teachingPlan.notes.note3Bold': 'Powered by DQスクールダッシュボード',
    'teachingPlan.footer.copyright': 'DQ LAB Pte Ltd. 無断複写・転載を禁じます。Powered by DQ',
    'teachingPlan.footer.trademark': 'はDQ LAB Pte Ltd.の登録商標です。',

    // Preview page
    'preview.editModeActive': '編集モード有効',
    'preview.preAssessment': '事前評価',
    'preview.postAssessment': '事後評価',
    'preview.deck.download': 'HTMLをダウンロード',
    'preview.deck.preparing': 'HTMLを準備中…',
    'preview.deck.failed': 'スライドをダウンロード用に準備できませんでした。もう一度お試しください。',
    'preview.deck.noVideo': '動画はありません',
    'preview.deck.slideCount': 'スライド {count} 枚',
    'preview.deck.noSlides': 'スライドはまだありません',
    'preview.assessment.quickTestFirst': 'まずは簡単なテストをしてみましょう！',
    'preview.assessment.testKnowledgeSkills': '知識とスキルをテストしましょう！',
    'preview.assessment.introAlt': '評価の導入',
    'preview.assessment.introTitle': '評価の導入',
    'preview.assessment.noQuestions': '質問がありません。',
    'preview.tooltip.exitEditMode': '編集モードを終了',
    'preview.tooltip.editNotAvailableEnglish': '英語のみのコンテンツでは編集できません',
    'preview.tooltip.editToggleLanguage': '編集は英語以外の言語版でのみ利用できます。編集するには他の言語に切り替えてください。',
    'preview.tooltip.editSlideContent': 'スライド内容を編集',
    'preview.btn.viewNextSession': '次のセッションを見る',
    'preview.btn.viewNextSegment': '次のセグメントを見る',
    'preview.btn.hide': '非表示',
    'preview.btn.unhide': '表示',
    'preview.tts.voice': '音声',
    'preview.tts.noVoices': '利用可能な音声はまだありません',
    'preview.tts.rate': '速度',
    'preview.tts.pitch': '高さ',
    'preview.tts.volume': '音量',
    'preview.segment.introduction': '導入',
    'preview.segment.reflection': '振り返り',
    'preview.segment.recap': 'まとめ',
    'preview.segment.sessionScore': 'セッションスコア',
    'preview.toast.failedSave': '変更を保存できませんでした。もう一度お試しください。',
    'preview.toast.ttsBrowser': 'お使いのブラウザでは音声読み上げに問題があるようです。ブラウザをアップグレードするか、別のブラウザをお試しください。',
    'preview.toast.editNotAvailableEnglish': '英語のみのコンテンツでは編集できません。',
    'preview.toast.editToggleLanguage': '編集は英語以外の言語版でのみ利用できます。他の言語のコンテンツを表示するには切り替えてください。',
    'preview.toast.outlineNotReady': 'プログラムのアウトラインはまだ準備できていません。',
    'preview.toast.sessionNotAvailable': 'セッション「{title}」は利用できません。',
    'preview.toast.sessionGenerating': 'セッション「{title}」は生成中です。お待ちください。',
    'preview.selectSession': 'メニューからセッションを選択してコンテンツを表示',
    'preview.assessmentModal.hideConfirm': '評価を非表示にすると、このモジュールの全セッションの事前・事後評価が生徒に表示されなくなります。<br/>続行しますか？',
    'preview.assessmentModal.unhideConfirm': '評価を表示すると、このモジュールの全セッションの事前・事後評価が再度生徒に表示されます。<br/>続行しますか？',
    'preview.error.slideLayoutNotFound': 'エラー: スライドレイアウトが見つかりません',
    'preview.loadingSlides': 'スライドを読み込み中...',
    'preview.sidebar.moduleWithIndex': 'モジュール {index}: {title}',
    'preview.sidebar.unitWithIndex': 'ユニット {index}: {title}',
    'preview.sidebar.sessionWithIndex': 'セッション {index}: {title}',
    'preview.sidebar.view': '表示',
    'preview.sidebar.loadingSegments': 'セグメントを読み込み中...',
    'preview.sidebar.sessionActivitiesLine': 'アクティビティ · 振り返り · 評価',
    'preview.btn.viewPreviousSegment': '前のセグメントを見る',
    'slide.activity.journalingTime': '振り返りタイム！',
    'slide.activity.shareWorkTime': '共有タイム！',
    'slide.activity.pollTime': '投票タイム！',
    'slide.activity.discussionTime': 'ディスカッションタイム！',
    'slide.activity.letsTalkAboutIt': '話し合いましょう',
    'slide.activity.yourSessionScore': 'あなたのセッションスコア',
    'slide.activity.journalingPlaceholder': 'ここに振り返りを書いてください...',
    'slide.activity.shareLinkPlaceholder': '共有リンクをここに貼り付けてください（Google ドライブ、Dropbox など）',
    'slide.activity.save': '保存',
    'slide.activity.submit': '送信',
    'slide.assessment.moduleScoreTitle': 'モジュール{module}の評価スコア',
    'slide.assessment.moduleScoreTitleGeneric': 'モジュールの評価スコア',
    'slide.assessment.sessionScoreTitle': 'セッション評価スコア',
    'slide.assessment.rubricLevel': 'レベル',
    'slide.assessment.rubricDescription': '説明',
    'slide.assessment.rubricHigh': '高い',
    'slide.assessment.rubricModerate': '中程度',
    'slide.assessment.rubricBasic': '基本',
    'slide.assessment.rubricLow': '低い',
    'slide.assessment.rubricHighDesc': '結果から、このトピックを深く理解していることがうかがえます。強みを生かして、学んだことを新しい場面で活用してみましょう。',
    'slide.assessment.rubricModerateDesc': '結果から、このトピックをよく理解しているものの、一部に不十分な点があることがうかがえます。その部分を復習し、学んだことを引き続き練習しましょう。',
    'slide.assessment.rubricBasicDesc': '結果から、いくつかの重要な考え方を理解していることがうかがえます。基本を復習し、練習を重ねて知識とスキルを伸ばしましょう。',
    'slide.assessment.rubricLowDesc': '結果から、重要な考え方にさらに注意を向ける必要があることがうかがえます。例をもう一度確認し、一歩ずつ理解を深めましょう。',

    // Slide component – learning content layout labels
    'slide.content.pictureThis': '想像してみてください：',
    'slide.content.illustrativeExample': '具体例',
    'slide.content.learningObjective': '学習目標',
    'slide.content.todaysQuestion': '今日の問い',
    'slide.content.summary': 'まとめ',
    'slide.caseStudy.story': 'ストーリー',
    'slide.caseStudy.meet': '登場人物',
    'slide.caseStudy.problem': '問題',
    'slide.caseStudy.choice': '選択',
    'slide.caseStudy.stopAndThink': '立ち止まって考えよう',
    'slide.caseStudy.risks': 'どんな問題が起こりうる？',
    'slide.caseStudy.whatHappened': '何が起きたか',
    'slide.caseStudy.bigIdea': '大切な考え',
    'slide.caseStudy.itsLike': 'たとえるなら…',
    'slide.caseStudy.letsTalk': '話し合おう',
    'slide.lab.goal': '目標',
    'slide.lab.prerequisites': '始める前に',
    'slide.lab.tools': 'ツール',
    'slide.lab.steps': '手順',
    'slide.lab.expectedResult': '期待される結果',
    'slide.lab.checkpoint': 'チェックポイント',
    'slide.lab.deliverable': '成果物',
    'slide.lab.resources': '参考資料',
    'slide.lab.copy': 'コピー',
    'slide.lab.copied': 'コピーしました',
    'slide.lab.timeBox': '{minutes}分',
    'slide.lab.kind.build': '構築',
    'slide.lab.kind.debug': 'デバッグ',
    'slide.lab.kind.extend': '拡張',
    'slide.lab.artifact.prompt': 'プロンプト',
    'slide.lab.artifact.code': 'コード',
    'slide.lab.artifact.config': '設定',
    'slide.lab.artifact.command': 'コマンド',
    'slide.lab.artifact.template': 'テンプレート',
    'slide.lab.artifact.sample': 'サンプル',
    'slide.lab.artifact.checklist': 'チェックリスト',
    'slide.lab.kind.start': 'はじめに',
    'slide.lab.files': 'ファイル',
    'slide.lab.troubleshooting': 'うまくいかないとき',
    'slide.lab.explainPrefix': '新しい用語',
    'slide.lab.successCriteria': 'このようにできれば達成です',
    'slide.lab.predictPrefix': 'まず予想',
    'slide.lab.youWritePrefix': '自分で書く',
    'slide.lab.showAnswerKey': '解答を見る（自分の答えを書いてから）',
    'slide.lab.revealPrefix': '予想を確かめる（答えてから）',
    'slide.lab.where.terminal': 'ターミナル',
    'slide.lab.where.codeEditor': 'コードエディター',
    'slide.lab.where.browser': 'ブラウザー',
    'slide.lab.where.app': 'アプリ',
    'slide.lab.where.notebook': 'ノートブック',
    'slide.lab.where.phone': 'スマートフォン',
    'slide.lab.where.document': 'ドキュメント',
    'slide.lab.where.aiChat': 'AIチャット',
    'slide.lab.where.spreadsheet': 'スプレッドシート',
    'slide.lab.where.adminConsole': '管理コンソール',
    'slide.map.coreSkill': '身につけるスキル',
    'slide.map.parts': 'スキルの全体像（今日の部分に印）',
    'slide.map.partsNext': 'スキルの全体像（次に学ぶこと）',
    'slide.map.scope': 'このセッション',
    'slide.map.status.today': '今日',
    'slide.map.status.earlier': '済み',
    'slide.map.status.later': '今後',
    'slide.example.inRealSystem': '実際のシステムでは',
    'slide.example.notice': '注目するポイント',
    'slide.example.takeaway': 'まとめ',
    'slide.example.kind.json': 'JSON',
    'slide.example.kind.pseudocode': '疑似コード',
    'slide.example.kind.log': 'ログ',
    'slide.example.kind.flow': 'フロー',
    'slide.example.kind.table': '表',
    'slide.overview.why': 'なぜ大切か',
    'slide.overview.coreIdea': 'ひとことで言うと',
    'slide.overview.finalResult': '作るもの',
    'slide.overview.howItWorks': 'しくみ',
    'slide.overview.tools': '使うツール',
    'slide.overview.youWillNeed': '必要なもの',
    'slide.prep.title': '始める前に',
    'slide.prep.badge': '自習 · 約{n}分 · 授業時間外',
    'slide.prep.badgeNoTime': '自習 · 授業時間外',
    'slide.prep.search': '検索: {phrase}',
    'slide.prep.withGrownUp': 'おとなの人といっしょに読もう',
    'slide.narrative.oldWorkflow': 'これまでの進め方',
    'slide.narrative.before': 'これまで',
    'slide.narrative.newWorkflow': 'これからの進め方',
    'slide.narrative.after': 'これから',
    'slide.narrative.temptingShortcut': '陥りやすい近道',
    'slide.narrative.theShortcut': '近道',
    'slide.narrative.safetyBuffer': '安全バッファ',
    'slide.narrative.thoughtfulResponse': '思慮深い対応',
    'slide.narrative.shortcutTaken': '近道を選んだ場合',
    'slide.narrative.catastrophicOutcome': '重大な結果',
    'slide.narrative.downstreamOutcome': '波及する結果：',
    'slide.spectrum.wrongMindset': '誤った考え方',
    'slide.spectrum.rightMindset': '正しい考え方',
    'slide.sequence.beforeOperations': '1. 作業前',
    'slide.sequence.firstSteps': '1. 最初のステップ',
    'slide.sequence.afterOperations': '2. 作業後',
    'slide.sequence.nextActions': '2. 次のアクション',
    'slide.modifier.watchOuts': '注意事項',
    'slide.modifier.whatThisIsNot': '注意点（これではないもの）：',
    'slide.outcome.ifYouDoThisWell': '実践できた場合',
    'slide.outcome.ifYouSkipThis': '省略した場合',
    'slide.reveal.correct': '正解です！',
    'slide.reveal.incorrect': '正解はこちら：',
    'slide.reentry.walkedInWith': '学ぶ前の状態',
    'slide.reentry.walkedOutWith': '学んだ後の状態',
    'slide.reentry.situation': 'こんな状況のとき',
    'slide.reentry.goBackTo': '戻るセクション',
    'slide.recap.titleDefault': '学びの整理',
    'slide.recap.ourBigQuestion': '今回の大きな問い：',
    'slide.recap.shortAnswer': '結論（要約）：',
    'slide.recap.howWhatYouLearned': '学んだ内容による裏付け：',
    'slide.shareWork.starterScenario': '初期シナリオ',
    'slide.shareWork.successCriteria': '成功基準',
    'slide.shareWork.tacticalTip': '実践のヒント：',
    'slide.analysis.howToApply': '活用方法：',
    'slide.workedExample.takeaway': '要点：',
    'slide.pledge.iPledge': '誓約する',
    'slide.video.notSupported': 'お使いのブラウザはvideoタグに対応していません。',
  },

  'th-TH': {
    // Duration formatting
    'duration.minutes': 'นาที',
    'duration.hour': 'ชั่วโมง',
    'duration.hours': 'ชั่วโมง',
    'duration.and': 'และ',
    
    // Outline page
    'outline.editModeActive': 'โหมดแก้ไขกำลังทำงาน',
    'outline.tooltip.saveChanges': 'บันทึกการเปลี่ยนแปลง',
    'outline.tooltip.editProgramName': 'แก้ไขชื่อโปรแกรม',
    'outline.tooltip.download': 'ดาวน์โหลด',
    'outline.tooltip.exitEditMode': 'ออกจากโหมดแก้ไข',
    'outline.tooltip.editOutlineContent': 'แก้ไขเนื้อหาโครงร่าง',
    'outline.tooltip.edit': 'แก้ไข',
    'outline.tooltip.collapseDetails': 'ยุบเพื่อซ่อนรายละเอียด',
    'outline.tooltip.expandDetails': 'ขยายเพื่อดูรายละเอียด',
    'outline.tooltip.removeItem': 'ลบรายการนี้',

    'outline.btn.save': 'บันทึก',
    'outline.btn.saving': 'กำลังบันทึก...',
    'outline.btn.cancel': 'ยกเลิก',
    'outline.btn.startOver': 'เริ่มใหม่',
    'outline.btn.generateProgram': 'สร้างโปรแกรม',
    'outline.btn.goBack': 'ย้อนกลับ',
    'outline.btn.discard': 'ทิ้ง',
    'outline.btn.saveChanges': 'บันทึกการเปลี่ยนแปลง',
    'outline.btn.yesRemove': 'ใช่, ลบ',
    'outline.btn.yesGenerate': 'ใช่, สร้าง',

    'outline.title.suffix': 'โครงร่างโปรแกรม',
    'outline.placeholder.enterProgramName': 'กรอกชื่อโปรแกรม',

    'outline.section.learners': 'ผู้เรียน',
    'outline.section.programStructure': 'โครงสร้างโปรแกรม',
    'outline.section.programLength': 'ระยะเวลาโปรแกรม',
    'outline.section.overview': 'ภาพรวม:',

    'outline.structure.summary': '{modules} โมดูล / {units} หน่วย / {sessions} เซสชัน',
    'outline.duration.minutes': '{minutes} นาที',
    'outline.duration.totalMinutes': '(รวม {minutes} นาที)',
    'outline.label.moduleWithIndex': 'โมดูล {index}: {title}',
    'outline.label.unitWithIndex': 'หน่วย {index}: {title}',
    'outline.label.sessionWithIndex': 'เซสชัน {index}: {title}',
    'outline.section.sessionLearningObjectives': 'วัตถุประสงค์การเรียนรู้ของเซสชัน:',

    'outline.educator': 'ผู้สอน',
    'outline.learner': 'ผู้เรียน',
    'outline.ksab.knowledge': 'ความรู้',
    'outline.ksab.skills': 'ทักษะ',
    'outline.ksab.attitudes': 'ทัศนคติ',
    'outline.ksab.behaviours': 'พฤติกรรม',

    'outline.frameworksAligned': 'กรอบงานที่สอดคล้อง',
    'outline.noFrameworksAligned': 'ไม่มีกรอบงานที่สอดคล้องสำหรับโมดูลนี้',

    'outline.targetGroup.general': 'บุคคลทั่วไป',
    'outline.targetGroup.children': 'เด็ก',
    'outline.targetGroup.teens': 'วัยรุ่น',
    'outline.targetAge.8_9': 'อายุ 8-9 ปี',
    'outline.targetAge.10_12': 'อายุ 10-12 ปี',
    'outline.targetAge.13_14': 'อายุ 13-14 ปี',
    'outline.targetAge.15_18': 'อายุ 15-18 ปี',
    'outline.targetAge.allAges': 'ทุกช่วงวัย',
    'outline.targetAge.workforce': 'วัยทำงาน',
    'outline.targetTier.T1': 'ประถมศึกษาตอนต้น (อายุ 7–9 ปี)',
    'outline.targetTier.T2': 'ประถมศึกษาตอนปลาย (อายุ 10–12 ปี)',
    'outline.targetTier.T3': 'มัธยมศึกษาตอนต้น (อายุ 13–14 ปี)',
    'outline.targetTier.T4': 'มัธยมศึกษาตอนปลาย (อายุ 15–17 ปี)',
    'outline.targetTier.T5': 'อุดมศึกษา/มหาวิทยาลัย (อายุ 18–22 ปี)',
    'outline.targetTier.T6': 'บุคคลทั่วไป (ทุกช่วงวัย)',
    'outline.targetTier.T7': 'วัยทำงาน',

    'outline.toast.editNotAvailableEnglish': 'ไม่สามารถแก้ไขสำหรับภาษาอังกฤษได้ โปรดเลือกภาษาอื่น',
    'outline.toast.failedOpenPdf': 'ไม่สามารถเปิด PDF ได้',
    'outline.toast.failedSaveOutline': 'บันทึกโครงร่างไม่สำเร็จ',
    'outline.toast.failedRemoval': 'ลบรายการไม่สำเร็จ',

    'outline.dialog.removeItem.title': 'คุณแน่ใจหรือไม่ว่าต้องการลบ {type} นี้?',
    'outline.dialog.removeProgram.html': 'คุณแน่ใจหรือไม่ว่าต้องการลบโปรแกรมนี้?<br/>การดำเนินการนี้ไม่สามารถย้อนกลับได้',
    'outline.dialog.lastItem.title.program': 'คำเตือน: ลบโปรแกรมปัจจุบัน',
    'outline.dialog.lastItem.title.module': 'คำเตือน: ลบโมดูล',
    'outline.dialog.lastItem.title.unit': 'คำเตือน: ลบหน่วย',
    'outline.dialog.lastItem.body.program.html':
      'นี่คือ {type} รายการสุดท้ายในโปรแกรม<br/>การลบนี้จะ <strong>ลบโปรแกรมปัจจุบันทั้งหมด</strong> และสร้างโปรแกรมใหม่<br/>คุณต้องการดำเนินการต่อหรือไม่? การดำเนินการนี้ไม่สามารถย้อนกลับได้',
    'outline.dialog.lastItem.body.module.html':
      'นี่คือ {type} รายการสุดท้ายในโมดูลนี้<br/>การลบ {type} นี้จะ <strong>ลบโมดูลทั้งหมด</strong> ด้วย<br/>คุณต้องการดำเนินการต่อหรือไม่? การดำเนินการนี้ไม่สามารถย้อนกลับได้',
    'outline.dialog.lastItem.body.unit.html':
      'นี่คือ {type} รายการสุดท้ายในหน่วยนี้<br/>การลบ {type} นี้จะ <strong>ลบหน่วยทั้งหมด</strong> ด้วย<br/>คุณต้องการดำเนินการต่อหรือไม่? การดำเนินการนี้ไม่สามารถย้อนกลับได้',
    'outline.dialog.lastItem.confirm.program': 'ใช่, ลบโปรแกรม',
    'outline.dialog.lastItem.confirm.module': 'ใช่, ลบโมดูล',
    'outline.dialog.lastItem.confirm.unit': 'ใช่, ลบหน่วย',

    'outline.dialog.generate.body.html':
      'คุณแน่ใจหรือไม่ว่าต้องการสร้างโปรแกรมนี้ด้วย <b>{count} เซสชัน?</b><br/>เมื่อสร้างแล้ว คุณจะไม่สามารถแก้ไขได้ และจะถูกเรียกเก็บเงินตามจำนวนเซสชันที่สร้าง',

    'outline.dialog.unsaved.title': 'มีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก',
    'outline.dialog.unsaved.body': 'คุณมีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก บันทึกตอนนี้หรือจะถูกทิ้ง',
    
    // Outline PDF/HTML documents
    'outlineDoc.title.prefix': 'โครงร่างโปรแกรมสำหรับ',
    'outlineDoc.viewType.educator': 'มุมมองผู้สอน',
    'outlineDoc.viewType.learner': 'มุมมองผู้เรียน',
    'outlineDoc.meta.learners': 'ผู้เรียน:',
    'outlineDoc.meta.programStructure': 'โครงสร้างโปรแกรม:',
    'outlineDoc.meta.programLength': 'ระยะเวลาโปรแกรม:',
    'outlineDoc.meta.notSpecified': 'ไม่ได้ระบุ',
    'outlineDoc.structure.modules': 'โมดูล',
    'outlineDoc.structure.units': 'หน่วย',
    'outlineDoc.structure.sessions': 'เซสชัน',
    'outlineDoc.section.overview': 'ภาพรวม:',
    'outlineDoc.ksab.label': 'KSAB:',
    'outlineDoc.ksab.knowledge': 'ความรู้',
    'outlineDoc.ksab.skills': 'ทักษะ',
    'outlineDoc.ksab.attitudes': 'ทัศนคติ',
    'outlineDoc.ksab.behaviours': 'พฤติกรรม',
    'outlineDoc.dqCode.label': 'รหัส DQ:',
    'outlineDoc.module.label': 'โมดูล',
    'outlineDoc.unit.label': 'หน่วย',
    'outlineDoc.session.label': 'เซสชัน',
    'outlineDoc.session.learningObjectives': 'วัตถุประสงค์การเรียนรู้ของเซสชัน:',
    'outlineDoc.frameworksAligned': 'กรอบความคิดที่สอดคล้อง:',
    'outlineDoc.noFrameworks': 'ไม่มีกรอบความคิดที่สอดคล้องสำหรับโปรแกรมนี้',
    'outlineDoc.footer.copyright': 'DQ LAB Pte Ltd. สงวนลิขสิทธิ์ Powered by DQ',
    'outlineDoc.footer.trademark': 'เป็นเครื่องหมายการค้าจดทะเบียนของ DQ LAB Pte Ltd.',

    // Teaching Plan PDF/HTML documents
    'teachingPlan.title.suffix': 'แผนการสอนสำหรับผู้สอน',
    'teachingPlan.meta.learners': 'ผู้เรียน:',
    'teachingPlan.meta.programStructure': 'โครงสร้างโปรแกรม:',
    'teachingPlan.meta.programLength': 'ระยะเวลาโปรแกรม:',
    'teachingPlan.meta.notSpecified': 'ไม่ได้ระบุ',
    'teachingPlan.structure.modules': 'โมดูล',
    'teachingPlan.structure.units': 'หน่วย',
    'teachingPlan.structure.sessions': 'เซสชัน',
    'teachingPlan.section.overview': 'ภาพรวม',
    'teachingPlan.section.preparingClass': 'การเตรียมห้องเรียนของคุณ',
    'teachingPlan.prep.beforeBeginning': 'ก่อนเริ่มโปรแกรม:',
    'teachingPlan.prep.internetAccess': 'ตรวจสอบให้แน่ใจว่าห้องเรียนของคุณมี{bold1}และ{bold2}(คอมพิวเตอร์หรือแท็บเล็ต)',
    'teachingPlan.prep.internetAccessBold1': 'การเชื่อมต่ออินเทอร์เน็ต',
    'teachingPlan.prep.internetAccessBold2': 'อุปกรณ์ดิจิทัล',
    'teachingPlan.prep.studentAccounts': 'ยืนยันว่านักเรียนทุกคนมีบัญชีและสามารถเข้าสู่ระบบ{link}ได้',
    'teachingPlan.prep.studentAccountsLink': 'www.dqforall.com',
    'teachingPlan.prep.websiteBlocked': 'หากเว็บไซต์ถูกบล็อก ให้ขอให้{bold}ของคุณเพิ่มในรายการที่อนุญาตหรือปลดบล็อก',
    'teachingPlan.prep.websiteBlockedBold': 'ผู้ดูแลระบบ',
    'teachingPlan.prep.headphones': 'สนับสนุนให้นักเรียนนำ{bold}มา (กิจกรรมบางอย่างรวมถึงวิดีโอหรือเสียง)',
    'teachingPlan.prep.headphonesBold': 'หูฟัง',
    'teachingPlan.module.label': 'โมดูล',
    'teachingPlan.unit.label': 'หน่วย',
    'teachingPlan.session.label': 'เซสชัน',
    'teachingPlan.session.untitled': 'เซสชันที่ไม่มีชื่อ',
    'teachingPlan.session.learningObjectives': 'วัตถุประสงค์การเรียนรู้ของเซสชัน',
    'teachingPlan.table.estimatedTime': 'เวลาโดยประมาณ',
    'teachingPlan.table.segment': 'ส่วน',
    'teachingPlan.table.activities': 'กิจกรรม',
    'teachingPlan.table.description': 'คำอธิบาย',
    'teachingPlan.table.minutes': 'นาที',
    'teachingPlan.segment.introduction': 'บทนำ',
    'teachingPlan.segment.introduction.activity1': 'ดูสไลด์เนื้อหา',
    'teachingPlan.segment.introduction.activity2': 'ดูวิดีโอแนะนำ',
    'teachingPlan.segment.introduction.description': 'นักเรียนจะได้รับการแนะนำหัวข้อเซสชันและวัตถุประสงค์การเรียนรู้',
    'teachingPlan.segment.preAssessment': 'การประเมินก่อนเรียน',
    'teachingPlan.segment.preAssessment.activity1': 'ทำคำถามประเมิน',
    'teachingPlan.segment.preAssessment.activity2': 'การประเมินตนเอง',
    'teachingPlan.segment.preAssessment.description': 'นักเรียนทำการประเมินก่อนเรียนเพื่อวัดความรู้ที่มีอยู่เกี่ยวกับหัวข้อ',
    'teachingPlan.segment.learningObjective': 'วัตถุประสงค์การเรียนรู้',
    'teachingPlan.segment.slo.activity1': 'กิจกรรมเชิงโต้ตอบ',
    'teachingPlan.segment.slo.activity2': 'การฝึกฝนแบบมีคำแนะนำ',
    'teachingPlan.segment.slo.activity3': 'ตอบแบบสำรวจ',
    'teachingPlan.segment.slo.activity4': 'ประยุกต์ใช้แนวคิด',
    'teachingPlan.segment.slo.description': 'นักเรียนมีส่วนร่วมกับเนื้อหาการเรียนรู้ผ่านกิจกรรมเชิงโต้ตอบ',
    'teachingPlan.segment.mainContent': 'เนื้อหาหลัก',
    'teachingPlan.segment.mainContent.activity1': 'กิจกรรมการเรียนรู้เชิงโต้ตอบ',
    'teachingPlan.segment.mainContent.activity2': 'การสำรวจแบบมีคำแนะนำ',
    'teachingPlan.segment.mainContent.activity3': 'การอภิปรายกลุ่ม',
    'teachingPlan.segment.mainContent.description': 'นักเรียนมีส่วนร่วมกับเนื้อหาการเรียนรู้หลักผ่านกิจกรรมเชิงโต้ตอบและการอภิปราย',
    'teachingPlan.segment.reflection': 'การไตร่ตรอง',
    'teachingPlan.segment.reflection.activity1': 'การไตร่ตรองส่วนบุคคล',
    'teachingPlan.segment.reflection.activity2': 'ตอบคำถามไตร่ตรอง',
    'teachingPlan.segment.reflection.activity3': 'แบ่งปันความเข้าใจ',
    'teachingPlan.segment.reflection.description': 'นักเรียนไตร่ตรองเกี่ยวกับการเรียนรู้และแบ่งปันประเด็นสำคัญกับเพื่อน',
    'teachingPlan.segment.postAssessment': 'การประเมินหลังเรียน',
    'teachingPlan.segment.postAssessment.activity1': 'ทำคำถามประเมิน',
    'teachingPlan.segment.postAssessment.activity2': 'ทบทวนคำตอบ',
    'teachingPlan.segment.postAssessment.description': 'นักเรียนทำการประเมินหลังเรียนเพื่อแสดงความเข้าใจในแนวคิดที่เรียนรู้',
    'teachingPlan.segment.recap': 'สรุป',
    'teachingPlan.segment.recap.activity1': 'ทบทวนแนวคิดสำคัญ',
    'teachingPlan.segment.recap.activity2': 'เซสชันถาม-ตอบ',
    'teachingPlan.segment.recap.activity3': 'สรุป',
    'teachingPlan.segment.recap.description': 'ประเด็นการเรียนรู้สำคัญได้รับการทบทวนและเสริมเพื่อให้แน่ใจว่าเข้าใจ',
    'teachingPlan.section.teacherNotes': 'บันทึกของครู',
    'teachingPlan.notes.note1': 'รักษาสภาพแวดล้อมในห้องเรียนที่เปิดกว้างและอยากรู้อยากเห็น',
    'teachingPlan.notes.note2': 'เสริมบทเรียนตลอดเวลาโดยตรวจสอบกับนักเรียนหลังจากการสรุปแต่ละเซสชันโดยใช้การอภิปรายกลุ่มสดหรือกิจกรรมไตร่ตรองอย่างรวดเร็ว',
    'teachingPlan.notes.note3': 'ติดตามความคืบหน้าและผลกระทบผ่าน{bold}ของคุณ',
    'teachingPlan.notes.note3Bold': 'แดชบอร์ดโรงเรียน Powered by DQ',
    'teachingPlan.footer.copyright': 'DQ LAB Pte Ltd. สงวนลิขสิทธิ์ Powered by DQ',
    'teachingPlan.footer.trademark': 'เป็นเครื่องหมายการค้าจดทะเบียนของ DQ LAB Pte Ltd.',

    // Preview page
    'preview.editModeActive': 'โหมดแก้ไขกำลังทำงาน',
    'preview.preAssessment': 'แบบประเมินก่อนเรียน',
    'preview.postAssessment': 'แบบประเมินหลังเรียน',
    'preview.deck.download': 'ดาวน์โหลด HTML',
    'preview.deck.preparing': 'กำลังเตรียม HTML…',
    'preview.deck.failed': 'ไม่สามารถเตรียมสไลด์สำหรับดาวน์โหลดได้ โปรดลองอีกครั้ง',
    'preview.deck.noVideo': 'ไม่มีวิดีโอ',
    'preview.deck.slideCount': '{count} สไลด์',
    'preview.deck.noSlides': 'ยังไม่มีสไลด์',
    'preview.assessment.quickTestFirst': 'มาทำแบบทดสอบสั้น ๆ กันก่อน!',
    'preview.assessment.testKnowledgeSkills': 'มาทดสอบความรู้และทักษะของคุณกันเถอะ!',
    'preview.assessment.introAlt': 'บทนำแบบประเมิน',
    'preview.assessment.introTitle': 'บทนำแบบประเมิน',
    'preview.assessment.noQuestions': 'ไม่มีคำถาม',
    'preview.tooltip.exitEditMode': 'ออกจากโหมดแก้ไข',
    'preview.tooltip.editNotAvailableEnglish': 'ไม่สามารถแก้ไขเนื้อหาภาษาอังกฤษเท่านั้น',
    'preview.tooltip.editToggleLanguage': 'การแก้ไขใช้ได้เฉพาะเวอร์ชันภาษาอื่นเท่านั้น สลับไปภาษาอื่นเพื่อแก้ไข',
    'preview.tooltip.editSlideContent': 'แก้ไขเนื้อหาสไลด์',
    'preview.btn.viewNextSession': 'ดูเซสชันถัดไป',
    'preview.btn.viewNextSegment': 'ดูเซกเมนต์ถัดไป',
    'preview.btn.hide': 'ซ่อน',
    'preview.btn.unhide': 'แสดง',
    'preview.tts.voice': 'เสียง',
    'preview.tts.noVoices': 'ยังไม่มีเสียงให้ใช้',
    'preview.tts.rate': 'อัตรา',
    'preview.tts.pitch': 'ระดับเสียง',
    'preview.tts.volume': 'ความดัง',
    'preview.segment.introduction': 'บทนำ',
    'preview.segment.reflection': 'การสะท้อนคิด',
    'preview.segment.recap': 'สรุป',
    'preview.segment.sessionScore': 'คะแนนเซสชัน',
    'preview.toast.failedSave': 'บันทึกการเปลี่ยนแปลงไม่สำเร็จ โปรดลองอีกครั้ง',
    'preview.toast.ttsBrowser': 'การอ่านข้อความอาจมีปัญหากับเบราว์เซอร์ของคุณ กรุณาอัปเกรดเบราว์เซอร์หรือลองเบราว์เซอร์อื่น',
    'preview.toast.editNotAvailableEnglish': 'ไม่สามารถแก้ไขเนื้อหาภาษาอังกฤษเท่านั้น',
    'preview.toast.editToggleLanguage': 'การแก้ไขใช้ได้เฉพาะเวอร์ชันภาษาอื่น โปรดสลับเพื่อดูเนื้อหาภาษาอื่น',
    'preview.toast.outlineNotReady': 'โครงร่างโปรแกรมยังไม่พร้อม!',
    'preview.toast.sessionNotAvailable': 'เซสชัน "{title}" ไม่พร้อมใช้งาน',
    'preview.toast.sessionGenerating': 'กำลังสร้างเซสชัน "{title}" กรุณารอสักครู่',
    'preview.selectSession': 'เลือกเซสชันจากเมนูเพื่อดูเนื้อหา',
    'preview.assessmentModal.hideConfirm': 'การซ่อนการประเมินจะลบทั้งแบบประเมินก่อนและหลังเรียนสำหรับผู้เรียนในทุกเซสชันของโมดูลนี้<br/>คุณต้องการดำเนินการต่อหรือไม่?',
    'preview.assessmentModal.unhideConfirm': 'เมื่อคุณแสดงการประเมินนี้ ทั้งแบบประเมินก่อนและหลังเรียนในทุกเซสชันของโมดูลนี้จะแสดงต่อผู้เรียนอีกครั้ง<br/>คุณต้องการดำเนินการต่อหรือไม่?',
    'preview.error.slideLayoutNotFound': 'ข้อผิดพลาด: ไม่พบเค้าโครงสไลด์',
    'preview.loadingSlides': 'กำลังโหลดสไลด์...',
    'preview.sidebar.moduleWithIndex': 'โมดูล {index}: {title}',
    'preview.sidebar.unitWithIndex': 'หน่วย {index}: {title}',
    'preview.sidebar.sessionWithIndex': 'เซสชัน {index}: {title}',
    'preview.sidebar.view': 'ดู',
    'preview.sidebar.loadingSegments': 'กำลังโหลดเซกเมนต์...',
    'preview.sidebar.sessionActivitiesLine': 'กิจกรรม · การสะท้อนคิด · การประเมิน',
    'preview.btn.viewPreviousSegment': 'ดูเซกเมนต์ก่อนหน้า',
    'slide.activity.journalingTime': 'เวลาไตร่ตรอง!',
    'slide.activity.shareWorkTime': 'เวลาแชร์ผลงาน!',
    'slide.activity.pollTime': 'เวลาโพล!',
    'slide.activity.discussionTime': 'เวลาอภิปราย!',
    'slide.activity.letsTalkAboutIt': 'มาพูดคุยกัน',
    'slide.activity.yourSessionScore': 'คะแนนเซสชันของคุณ',
    'slide.activity.journalingPlaceholder': 'เริ่มเขียนการไตร่ตรองของคุณที่นี่...',
    'slide.activity.shareLinkPlaceholder': 'วางลิงก์ที่แชร์ได้ที่นี่ (เช่น Google Drive, Dropbox)',
    'slide.activity.save': 'บันทึก',
    'slide.activity.submit': 'ส่ง',
    'slide.assessment.moduleScoreTitle': 'คะแนนการประเมินของโมดูล {module}',
    'slide.assessment.moduleScoreTitleGeneric': 'คะแนนการประเมินของโมดูล',
    'slide.assessment.sessionScoreTitle': 'คะแนนการประเมินของเซสชัน',
    'slide.assessment.rubricLevel': 'ระดับ',
    'slide.assessment.rubricDescription': 'คำอธิบาย',
    'slide.assessment.rubricHigh': 'สูง',
    'slide.assessment.rubricModerate': 'ปานกลาง',
    'slide.assessment.rubricBasic': 'พื้นฐาน',
    'slide.assessment.rubricLow': 'ต่ำ',
    'slide.assessment.rubricHighDesc': 'ผลลัพธ์ของคุณแสดงให้เห็นว่าคุณเข้าใจหัวข้อนี้เป็นอย่างดี ต่อยอดจากจุดแข็งของคุณและลองนำสิ่งที่ได้เรียนรู้ไปใช้ในสถานการณ์ใหม่ ๆ',
    'slide.assessment.rubricModerateDesc': 'ผลลัพธ์ของคุณแสดงให้เห็นว่าคุณเข้าใจหัวข้อนี้ได้ดี แต่ยังมีบางส่วนที่ต้องเสริม ทบทวนส่วนเหล่านั้นและฝึกฝนสิ่งที่ได้เรียนรู้ต่อไป',
    'slide.assessment.rubricBasicDesc': 'ผลลัพธ์ของคุณแสดงให้เห็นว่าคุณเข้าใจแนวคิดสำคัญบางส่วน ทบทวนพื้นฐานและฝึกฝนเพื่อเสริมสร้างความรู้และทักษะของคุณ',
    'slide.assessment.rubricLowDesc': 'ผลลัพธ์ของคุณแสดงให้เห็นว่าแนวคิดสำคัญยังต้องได้รับความใส่ใจมากขึ้น กลับไปดูตัวอย่างอีกครั้งและค่อย ๆ สร้างความเข้าใจทีละขั้น',

    // Slide component – learning content layout labels
    'slide.content.pictureThis': 'ลองจินตนาการดู:',
    'slide.content.illustrativeExample': 'ตัวอย่างประกอบ',
    'slide.content.learningObjective': 'วัตถุประสงค์การเรียนรู้',
    'slide.content.todaysQuestion': 'คำถามประจำวันนี้',
    'slide.content.summary': 'สรุป',
    'slide.caseStudy.story': 'เรื่องราว',
    'slide.caseStudy.meet': 'มารู้จัก',
    'slide.caseStudy.problem': 'ปัญหา',
    'slide.caseStudy.choice': 'ทางเลือก',
    'slide.caseStudy.stopAndThink': 'หยุดคิดสักนิด',
    'slide.caseStudy.risks': 'อะไรอาจผิดพลาดได้บ้าง?',
    'slide.caseStudy.whatHappened': 'เกิดอะไรขึ้น',
    'slide.caseStudy.bigIdea': 'แนวคิดสำคัญ',
    'slide.caseStudy.itsLike': 'เหมือนกับ…',
    'slide.caseStudy.letsTalk': 'มาคุยกัน',
    'slide.lab.goal': 'เป้าหมาย',
    'slide.lab.prerequisites': 'ก่อนเริ่ม',
    'slide.lab.tools': 'เครื่องมือ',
    'slide.lab.steps': 'ขั้นตอน',
    'slide.lab.expectedResult': 'ผลลัพธ์ที่คาดหวัง',
    'slide.lab.checkpoint': 'จุดตรวจสอบ',
    'slide.lab.deliverable': 'ชิ้นงานที่ต้องส่ง',
    'slide.lab.resources': 'แหล่งข้อมูล',
    'slide.lab.copy': 'คัดลอก',
    'slide.lab.copied': 'คัดลอกแล้ว',
    'slide.lab.timeBox': '{minutes} นาที',
    'slide.lab.kind.build': 'สร้าง',
    'slide.lab.kind.debug': 'แก้จุดบกพร่อง',
    'slide.lab.kind.extend': 'ต่อยอด',
    'slide.lab.artifact.prompt': 'พรอมต์',
    'slide.lab.artifact.code': 'โค้ด',
    'slide.lab.artifact.config': 'การตั้งค่า',
    'slide.lab.artifact.command': 'คำสั่ง',
    'slide.lab.artifact.template': 'แม่แบบ',
    'slide.lab.artifact.sample': 'ตัวอย่าง',
    'slide.lab.artifact.checklist': 'รายการตรวจสอบ',
    'slide.lab.kind.start': 'เริ่มต้น',
    'slide.lab.files': 'ไฟล์',
    'slide.lab.troubleshooting': 'หากเกิดปัญหา',
    'slide.lab.explainPrefix': 'ใหม่',
    'slide.lab.successCriteria': 'คุณทำได้แล้วเมื่อ',
    'slide.lab.predictPrefix': 'คาดการณ์ก่อน',
    'slide.lab.youWritePrefix': 'คุณเขียนเอง',
    'slide.lab.showAnswerKey': 'ดูเฉลย (หลังจากตอบเองแล้ว)',
    'slide.lab.revealPrefix': 'ตรวจคำทำนาย (หลังจากตอบแล้ว)',
    'slide.lab.where.terminal': 'เทอร์มินัล',
    'slide.lab.where.codeEditor': 'โปรแกรมแก้ไขโค้ด',
    'slide.lab.where.browser': 'เบราว์เซอร์',
    'slide.lab.where.app': 'แอป',
    'slide.lab.where.notebook': 'โน้ตบุ๊ก',
    'slide.lab.where.phone': 'โทรศัพท์',
    'slide.lab.where.document': 'เอกสาร',
    'slide.lab.where.aiChat': 'แชต AI',
    'slide.lab.where.spreadsheet': 'สเปรดชีต',
    'slide.lab.where.adminConsole': 'คอนโซลผู้ดูแลระบบ',
    'slide.map.coreSkill': 'ทักษะ',
    'slide.map.parts': 'ส่วนต่าง ๆ ของทักษะ (ที่เรียนวันนี้มีเครื่องหมาย)',
    'slide.map.partsNext': 'ส่วนต่าง ๆ ของทักษะ (สิ่งที่จะเรียนต่อ)',
    'slide.map.scope': 'เซสชันนี้',
    'slide.map.status.today': 'วันนี้',
    'slide.map.status.earlier': 'เรียนแล้ว',
    'slide.map.status.later': 'ภายหลัง',
    'slide.example.inRealSystem': 'ในระบบจริง',
    'slide.example.notice': 'สิ่งที่ควรสังเกต',
    'slide.example.takeaway': 'ข้อสรุป',
    'slide.example.kind.json': 'JSON',
    'slide.example.kind.pseudocode': 'รหัสเทียม',
    'slide.example.kind.log': 'บันทึก',
    'slide.example.kind.flow': 'ลำดับขั้นตอน',
    'slide.example.kind.table': 'ตาราง',
    'slide.overview.why': 'ทำไมจึงสำคัญ',
    'slide.overview.coreIdea': 'แนวคิดในหนึ่งประโยค',
    'slide.overview.finalResult': 'สิ่งที่คุณจะสร้าง',
    'slide.overview.howItWorks': 'หลักการทำงาน',
    'slide.overview.tools': 'เครื่องมือที่จะใช้',
    'slide.overview.youWillNeed': 'สิ่งที่ต้องเตรียม',
    'slide.prep.title': 'ก่อนเริ่มเรียน',
    'slide.prep.badge': 'เรียนรู้ด้วยตนเอง · ประมาณ {n} นาที · นอกเวลาเรียน',
    'slide.prep.badgeNoTime': 'เรียนรู้ด้วยตนเอง · นอกเวลาเรียน',
    'slide.prep.search': 'ค้นหา: {phrase}',
    'slide.prep.withGrownUp': 'อ่านพร้อมกับผู้ใหญ่นะ',
    'slide.narrative.oldWorkflow': 'ขั้นตอนเดิม',
    'slide.narrative.before': 'ก่อนหน้านี้',
    'slide.narrative.newWorkflow': 'ขั้นตอนใหม่',
    'slide.narrative.after': 'หลังจากนี้',
    'slide.narrative.temptingShortcut': 'ทางลัดที่ดึงดูดใจ',
    'slide.narrative.theShortcut': 'ทางลัด',
    'slide.narrative.safetyBuffer': 'เกราะป้องกันความปลอดภัย',
    'slide.narrative.thoughtfulResponse': 'การตอบสนองอย่างรอบคอบ',
    'slide.narrative.shortcutTaken': 'เมื่อเลือกใช้ทางลัด',
    'slide.narrative.catastrophicOutcome': 'ผลลัพธ์ที่ร้ายแรง',
    'slide.narrative.downstreamOutcome': 'ผลลัพธ์ที่ตามมา:',
    'slide.spectrum.wrongMindset': 'กรอบความคิดที่ผิด',
    'slide.spectrum.rightMindset': 'กรอบความคิดที่ถูกต้อง',
    'slide.sequence.beforeOperations': '1. ก่อนเริ่มปฏิบัติการ',
    'slide.sequence.firstSteps': '1. ขั้นตอนแรก',
    'slide.sequence.afterOperations': '2. หลังปฏิบัติการ',
    'slide.sequence.nextActions': '2. ขั้นตอนต่อไป',
    'slide.modifier.watchOuts': 'ข้อควรระวัง',
    'slide.modifier.whatThisIsNot': 'สิ่งนี้ไม่ใช่:',
    'slide.outcome.ifYouDoThisWell': 'หากคุณทำได้ดี',
    'slide.outcome.ifYouSkipThis': 'หากคุณข้ามสิ่งนี้',
    'slide.reveal.correct': 'ถูกต้อง!',
    'slide.reveal.incorrect': 'คำตอบที่ถูกต้องคือ',
    'slide.reentry.walkedInWith': 'ก่อนเริ่มเรียนคุณมาพร้อมกับ',
    'slide.reentry.walkedOutWith': 'หลังเรียนจบคุณได้รับ',
    'slide.reentry.situation': 'สถานการณ์',
    'slide.reentry.goBackTo': 'ย้อนกลับไปที่',
    'slide.recap.titleDefault': 'ประมวลสรุปทั้งหมด',
    'slide.recap.ourBigQuestion': 'คำถามสำคัญของเรา:',
    'slide.recap.shortAnswer': 'คำตอบโดยย่อ:',
    'slide.recap.howWhatYouLearned': 'สิ่งที่ได้เรียนรู้สนับสนุนคำตอบนี้อย่างไร:',
    'slide.shareWork.starterScenario': 'สถานการณ์เริ่มต้น',
    'slide.shareWork.successCriteria': 'เกณฑ์ความสำเร็จ',
    'slide.shareWork.tacticalTip': 'เคล็ดลับเชิงปฏิบัติ:',
    'slide.analysis.howToApply': 'วิธีนำไปใช้:',
    'slide.workedExample.takeaway': 'ข้อคิดสำคัญ:',
    'slide.pledge.iPledge': 'ฉันให้คำมั่น',
    'slide.video.notSupported': 'เบราว์เซอร์ของคุณไม่รองรับแท็กวิดีโอ',
  },

  'ko-KR': {
    // Duration formatting
    'duration.minutes': '분',
    'duration.hour': '시간',
    'duration.hours': '시간',
    'duration.and': '및',
    
    // Outline page
    'outline.editModeActive': '편집 모드 활성화',
    'outline.tooltip.saveChanges': '변경사항 저장',
    'outline.tooltip.editProgramName': '프로그램 이름 편집',
    'outline.tooltip.download': '다운로드',
    'outline.tooltip.exitEditMode': '편집 모드 종료',
    'outline.tooltip.editOutlineContent': '개요 내용 편집',
    'outline.tooltip.edit': '편집',
    'outline.tooltip.collapseDetails': '접어서 세부정보 숨기기',
    'outline.tooltip.expandDetails': '펼쳐서 세부정보 보기',
    'outline.tooltip.removeItem': '이 항목 제거',

    'outline.btn.save': '저장',
    'outline.btn.saving': '저장 중...',
    'outline.btn.cancel': '취소',
    'outline.btn.startOver': '처음부터',
    'outline.btn.generateProgram': '프로그램 생성',
    'outline.btn.goBack': '뒤로',
    'outline.btn.discard': '버리기',
    'outline.btn.saveChanges': '변경사항 저장',
    'outline.btn.yesRemove': '예, 제거',
    'outline.btn.yesGenerate': '예, 생성',

    'outline.title.suffix': '프로그램 개요',
    'outline.placeholder.enterProgramName': '프로그램 이름 입력',

    'outline.section.learners': '학습자',
    'outline.section.programStructure': '프로그램 구성',
    'outline.section.programLength': '프로그램 길이',
    'outline.section.overview': '개요:',
    'outline.section.sessionLearningObjectives': '세션 학습 목표:',

    'outline.structure.summary': '{modules}개 모듈 / {units}개 유닛 / {sessions}개 세션',
    'outline.duration.minutes': '{minutes}분',
    'outline.duration.totalMinutes': '(총 {minutes}분)',
    'outline.label.moduleWithIndex': '모듈 {index}: {title}',
    'outline.label.unitWithIndex': '유닛 {index}: {title}',
    'outline.label.sessionWithIndex': '세션 {index}: {title}',

    'outline.educator': '교육자',
    'outline.learner': '학습자',
    'outline.ksab.knowledge': '지식',
    'outline.ksab.skills': '기술',
    'outline.ksab.attitudes': '태도',
    'outline.ksab.behaviours': '행동',

    'outline.frameworksAligned': '정렬된 프레임워크',
    'outline.noFrameworksAligned': '이 모듈에 정렬된 프레임워크가 없습니다',

    'outline.targetGroup.general': '일반 대중',
    'outline.targetGroup.children': '어린이',
    'outline.targetGroup.teens': '청소년',
    'outline.targetAge.8_9': '8-9세',
    'outline.targetAge.10_12': '10-12세',
    'outline.targetAge.13_14': '13-14세',
    'outline.targetAge.15_18': '15-18세',
    'outline.targetAge.allAges': '전 연령',
    'outline.targetAge.workforce': '직장인',
    'outline.targetTier.T1': '초등 저학년 (7-9세)',
    'outline.targetTier.T2': '초등 고학년 (10-12세)',
    'outline.targetTier.T3': '중학교 (13-14세)',
    'outline.targetTier.T4': '고등학교 (15-17세)',
    'outline.targetTier.T5': '대학교/고등교육 (18-22세)',
    'outline.targetTier.T6': '일반 대중 (전 연령)',
    'outline.targetTier.T7': '직장인',

    'outline.toast.editNotAvailableEnglish': '영어에서는 편집할 수 없습니다. 다른 언어를 선택해 주세요.',
    'outline.toast.failedOpenPdf': 'PDF를 열지 못했습니다',
    'outline.toast.failedSaveOutline': '개요를 저장하지 못했습니다',
    'outline.toast.failedRemoval': '삭제 작업을 완료하지 못했습니다',

    'outline.dialog.removeItem.title': '이 {type}을(를) 삭제하시겠어요?',
    'outline.dialog.removeProgram.html': '이 프로그램을 삭제하시겠습니까?<br/>이 작업은 되돌릴 수 없습니다.',
    'outline.dialog.lastItem.title.program': '경고: 현재 프로그램 삭제',
    'outline.dialog.lastItem.title.module': '경고: 모듈 삭제',
    'outline.dialog.lastItem.title.unit': '경고: 유닛 삭제',
    'outline.dialog.lastItem.body.program.html':
      '프로그램의 마지막 {type}입니다.<br/>이를 제거하면 <strong>현재 프로그램 전체가 삭제</strong>되고 새 프로그램이 생성됩니다.<br/>계속하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
    'outline.dialog.lastItem.body.module.html':
      '이 모듈의 마지막 {type}입니다.<br/>이 {type}을(를) 제거하면 <strong>모듈 전체도 삭제</strong>됩니다.<br/>계속하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
    'outline.dialog.lastItem.body.unit.html':
      '이 유닛의 마지막 {type}입니다.<br/>이 {type}을(를) 제거하면 <strong>유닛 전체도 삭제</strong>됩니다.<br/>계속하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
    'outline.dialog.lastItem.confirm.program': '예, 프로그램 삭제',
    'outline.dialog.lastItem.confirm.module': '예, 모듈 삭제',
    'outline.dialog.lastItem.confirm.unit': '예, 유닛 삭제',

    'outline.dialog.generate.body.html':
      '이 프로그램을 <b>{count}개 세션</b>으로 생성하시겠습니까?<br/>생성 후에는 변경할 수 없으며, 생성된 세션 수만큼 청구됩니다.',

    'outline.dialog.unsaved.title': '저장되지 않은 변경사항',
    'outline.dialog.unsaved.body': '저장되지 않은 변경사항이 있습니다. 지금 저장하지 않으면 삭제됩니다.',

    // Outline PDF/HTML documents
    'outlineDoc.title.prefix': '프로그램 개요',
    'outlineDoc.viewType.educator': '교육자 보기',
    'outlineDoc.viewType.learner': '학습자 보기',
    'outlineDoc.meta.learners': '학습자:',
    'outlineDoc.meta.programStructure': '프로그램 구조:',
    'outlineDoc.meta.programLength': '프로그램 기간:',
    'outlineDoc.meta.notSpecified': '지정되지 않음',
    'outlineDoc.structure.modules': '모듈',
    'outlineDoc.structure.units': '유닛',
    'outlineDoc.structure.sessions': '세션',
    'outlineDoc.section.overview': '개요:',
    'outlineDoc.ksab.label': 'KSAB:',
    'outlineDoc.ksab.knowledge': '지식',
    'outlineDoc.ksab.skills': '기술',
    'outlineDoc.ksab.attitudes': '태도',
    'outlineDoc.ksab.behaviours': '행동',
    'outlineDoc.dqCode.label': 'DQ 코드:',
    'outlineDoc.module.label': '모듈',
    'outlineDoc.unit.label': '유닛',
    'outlineDoc.session.label': '세션',
    'outlineDoc.session.learningObjectives': '세션 학습 목표:',
    'outlineDoc.frameworksAligned': '정렬된 프레임워크:',
    'outlineDoc.noFrameworks': '이 프로그램에 정렬된 프레임워크가 없습니다',
    'outlineDoc.footer.copyright': 'DQ LAB Pte Ltd. 모든 권리 보유. Powered by DQ',
    'outlineDoc.footer.trademark': '는 DQ LAB Pte Ltd.의 등록 상표입니다.',

    // Teaching Plan PDF/HTML documents
    'teachingPlan.title.suffix': '교육자 지도 계획',
    'teachingPlan.meta.learners': '학습자:',
    'teachingPlan.meta.programStructure': '프로그램 구조:',
    'teachingPlan.meta.programLength': '프로그램 기간:',
    'teachingPlan.meta.notSpecified': '지정되지 않음',
    'teachingPlan.structure.modules': '모듈',
    'teachingPlan.structure.units': '유닛',
    'teachingPlan.structure.sessions': '세션',
    'teachingPlan.section.overview': '개요',
    'teachingPlan.section.preparingClass': '수업 준비',
    'teachingPlan.prep.beforeBeginning': '프로그램 시작 전:',
    'teachingPlan.prep.internetAccess': '교실에 {bold1}과 {bold2}(컴퓨터 또는 태블릿)가 있는지 확인하세요.',
    'teachingPlan.prep.internetAccessBold1': '인터넷 접속',
    'teachingPlan.prep.internetAccessBold2': '디지털 기기',
    'teachingPlan.prep.studentAccounts': '모든 학생이 계정을 가지고 있고 {link}에 로그인할 수 있는지 확인하세요.',
    'teachingPlan.prep.studentAccountsLink': 'www.dqforall.com',
    'teachingPlan.prep.websiteBlocked': '웹사이트가 차단된 경우 {bold}에게 화이트리스트에 추가하거나 차단 해제를 요청하세요.',
    'teachingPlan.prep.websiteBlockedBold': '시스템 관리자',
    'teachingPlan.prep.headphones': '학생들에게 {bold}를 가져오도록 권장하세요 (일부 활동에는 비디오 또는 오디오가 포함됨).',
    'teachingPlan.prep.headphonesBold': '헤드폰',
    'teachingPlan.module.label': '모듈',
    'teachingPlan.unit.label': '유닛',
    'teachingPlan.session.label': '세션',
    'teachingPlan.session.untitled': '제목 없는 세션',
    'teachingPlan.session.learningObjectives': '세션 학습 목표',
    'teachingPlan.table.estimatedTime': '예상 시간',
    'teachingPlan.table.segment': '구간',
    'teachingPlan.table.activities': '활동',
    'teachingPlan.table.description': '설명',
    'teachingPlan.table.minutes': '분',
    'teachingPlan.segment.introduction': '도입',
    'teachingPlan.segment.introduction.activity1': '콘텐츠 슬라이드 보기',
    'teachingPlan.segment.introduction.activity2': '소개 비디오 보기',
    'teachingPlan.segment.introduction.description': '학생들은 세션 주제와 학습 목표를 소개받습니다.',
    'teachingPlan.segment.preAssessment': '사전 평가',
    'teachingPlan.segment.preAssessment.activity1': '평가 문제 완료',
    'teachingPlan.segment.preAssessment.activity2': '자기 평가',
    'teachingPlan.segment.preAssessment.description': '학생들은 주제에 대한 기존 지식을 측정하기 위해 사전 평가를 완료합니다.',
    'teachingPlan.segment.learningObjective': '학습 목표',
    'teachingPlan.segment.slo.activity1': '대화형 활동',
    'teachingPlan.segment.slo.activity2': '안내된 연습',
    'teachingPlan.segment.slo.activity3': '설문 응답',
    'teachingPlan.segment.slo.activity4': '개념 적용',
    'teachingPlan.segment.slo.description': '학생들은 대화형 활동을 통해 학습 콘텐츠에 참여합니다.',
    'teachingPlan.segment.mainContent': '주요 콘텐츠',
    'teachingPlan.segment.mainContent.activity1': '대화형 학습 활동',
    'teachingPlan.segment.mainContent.activity2': '안내된 탐색',
    'teachingPlan.segment.mainContent.activity3': '그룹 토론',
    'teachingPlan.segment.mainContent.description': '학생들은 대화형 활동과 토론을 통해 핵심 학습 콘텐츠에 참여합니다.',
    'teachingPlan.segment.reflection': '성찰',
    'teachingPlan.segment.reflection.activity1': '개인 성찰',
    'teachingPlan.segment.reflection.activity2': '성찰 질문 답변',
    'teachingPlan.segment.reflection.activity3': '통찰력 공유',
    'teachingPlan.segment.reflection.description': '학생들은 자신의 학습을 성찰하고 동료들과 주요 요점을 공유합니다.',
    'teachingPlan.segment.postAssessment': '사후 평가',
    'teachingPlan.segment.postAssessment.activity1': '평가 문제 완료',
    'teachingPlan.segment.postAssessment.activity2': '답변 검토',
    'teachingPlan.segment.postAssessment.description': '학생들은 학습한 개념의 이해를 입증하기 위해 사후 평가를 완료합니다.',
    'teachingPlan.segment.recap': '요약',
    'teachingPlan.segment.recap.activity1': '주요 개념 검토',
    'teachingPlan.segment.recap.activity2': '질의응답 세션',
    'teachingPlan.segment.recap.activity3': '요약',
    'teachingPlan.segment.recap.description': '주요 학습 포인트가 검토되고 이해를 확실히 하기 위해 강화됩니다.',
    'teachingPlan.section.teacherNotes': '교사 노트',
    'teachingPlan.notes.note1': '개방적이고 호기심 많은 교실 환경을 유지하세요.',
    'teachingPlan.notes.note2': '라이브 그룹 토론이나 빠른 성찰 활동을 사용하여 각 세션 요약 후 학생들과 확인함으로써 수업을 계속 강화하세요.',
    'teachingPlan.notes.note3': '{bold}를 통해 진행 상황과 영향을 추적하세요.',
    'teachingPlan.notes.note3Bold': 'Powered by DQ 학교 대시보드',
    'teachingPlan.footer.copyright': 'DQ LAB Pte Ltd. 모든 권리 보유. Powered by DQ',
    'teachingPlan.footer.trademark': '는 DQ LAB Pte Ltd.의 등록 상표입니다.',

    // Preview page
    'preview.editModeActive': '편집 모드 활성화',
    'preview.preAssessment': '사전 평가',
    'preview.postAssessment': '사후 평가',
    'preview.deck.download': 'HTML 다운로드',
    'preview.deck.preparing': 'HTML 준비 중…',
    'preview.deck.failed': '슬라이드를 다운로드용으로 준비하지 못했습니다. 다시 시도해 주세요.',
    'preview.deck.noVideo': '동영상이 없습니다',
    'preview.deck.slideCount': '슬라이드 {count}장',
    'preview.deck.noSlides': '아직 슬라이드가 없습니다',
    'preview.assessment.quickTestFirst': '먼저 간단한 테스트를 해볼까요?',
    'preview.assessment.testKnowledgeSkills': '지식과 기술을 테스트해 봅시다!',
    'preview.assessment.introAlt': '평가 소개',
    'preview.assessment.introTitle': '평가 소개',
    'preview.assessment.noQuestions': '질문이 없습니다.',
    'preview.tooltip.exitEditMode': '편집 모드 종료',
    'preview.tooltip.editNotAvailableEnglish': '영어 전용 콘텐츠는 편집할 수 없습니다',
    'preview.tooltip.editToggleLanguage': '편집은 영어가 아닌 언어 버전에서만 가능합니다. 편집하려면 다른 언어로 전환하세요.',
    'preview.tooltip.editSlideContent': '슬라이드 내용 편집',
    'preview.btn.viewNextSession': '다음 세션 보기',
    'preview.btn.viewNextSegment': '다음 세그먼트 보기',
    'preview.btn.hide': '숨기기',
    'preview.btn.unhide': '표시',
    'preview.tts.voice': '음성',
    'preview.tts.noVoices': '아직 사용 가능한 음성이 없습니다',
    'preview.tts.rate': '속도',
    'preview.tts.pitch': '음높이',
    'preview.tts.volume': '음량',
    'preview.segment.introduction': '도입',
    'preview.segment.reflection': '성찰',
    'preview.segment.recap': '요약',
    'preview.segment.sessionScore': '세션 점수',
    'preview.toast.failedSave': '변경 사항을 저장하지 못했습니다. 다시 시도해 주세요.',
    'preview.toast.ttsBrowser': '브라우저에서 음성 합성에 문제가 있는 것 같습니다. 브라우저를 업그레이드하거나 다른 브라우저를 사용해 보세요.',
    'preview.toast.editNotAvailableEnglish': '영어 전용 콘텐츠는 편집할 수 없습니다.',
    'preview.toast.editToggleLanguage': '편집은 영어가 아닌 언어 버전에서만 가능합니다. 다른 언어 콘텐츠를 보려면 전환하세요.',
    'preview.toast.outlineNotReady': '학습 프로그램 개요가 아직 준비되지 않았습니다!',
    'preview.toast.sessionNotAvailable': '세션 "{title}"을(를) 사용할 수 없습니다.',
    'preview.toast.sessionGenerating': '세션 "{title}" 생성 중입니다. 잠시만 기다려 주세요.',
    'preview.selectSession': '메뉴에서 세션을 선택하여 콘텐츠 보기',
    'preview.assessmentModal.hideConfirm': '평가를 숨기면 이 모듈의 모든 세션에 있는 사전·사후 평가가 학생에게서 제거됩니다.<br/>계속하시겠습니까?',
    'preview.assessmentModal.unhideConfirm': '평가를 표시하면 이 모듈의 모든 세션에 있는 사전·사후 평가가 다시 학생에게 표시됩니다.<br/>계속하시겠습니까?',
    'preview.error.slideLayoutNotFound': '오류: 슬라이드 레이아웃을 찾을 수 없습니다',
    'preview.loadingSlides': '슬라이드 로딩 중...',
    'preview.sidebar.moduleWithIndex': '모듈 {index}: {title}',
    'preview.sidebar.unitWithIndex': '유닛 {index}: {title}',
    'preview.sidebar.sessionWithIndex': '세션 {index}: {title}',
    'preview.sidebar.view': '보기',
    'preview.sidebar.loadingSegments': '세그먼트 로딩 중...',
    'preview.sidebar.sessionActivitiesLine': '활동 · 성찰 · 평가',
    'preview.btn.viewPreviousSegment': '이전 세그먼트 보기',
    'slide.activity.journalingTime': '일기 작성 시간!',
    'slide.activity.shareWorkTime': '작업 공유 시간!',
    'slide.activity.pollTime': '투표 시간!',
    'slide.activity.discussionTime': '토론 시간!',
    'slide.activity.letsTalkAboutIt': '함께 이야기해요',
    'slide.activity.yourSessionScore': '당신의 세션 점수',
    'slide.activity.journalingPlaceholder': '여기에 성찰을 작성해 보세요...',
    'slide.activity.shareLinkPlaceholder': '공유 링크를 여기에 붙여넣으세요 (Google Drive, Dropbox 등)',
    'slide.activity.save': '저장',
    'slide.activity.submit': '제출',
    'slide.assessment.moduleScoreTitle': '모듈 {module} 평가 점수',
    'slide.assessment.moduleScoreTitleGeneric': '모듈 평가 점수',
    'slide.assessment.sessionScoreTitle': '세션 평가 점수',
    'slide.assessment.rubricLevel': '단계',
    'slide.assessment.rubricDescription': '설명',
    'slide.assessment.rubricHigh': '높음',
    'slide.assessment.rubricModerate': '보통',
    'slide.assessment.rubricBasic': '기초',
    'slide.assessment.rubricLow': '낮음',
    'slide.assessment.rubricHighDesc': '결과를 보면 이 주제를 깊이 이해하고 있습니다. 강점을 바탕으로 배운 내용을 새로운 상황에 적용해 보세요.',
    'slide.assessment.rubricModerateDesc': '결과를 보면 이 주제를 잘 이해하고 있지만 일부 부족한 부분이 있습니다. 해당 부분을 복습하고 배운 내용을 계속 연습해 보세요.',
    'slide.assessment.rubricBasicDesc': '결과를 보면 몇 가지 핵심 개념을 이해하고 있습니다. 기초를 복습하고 연습하여 지식과 역량을 키워 보세요.',
    'slide.assessment.rubricLowDesc': '결과를 보면 핵심 개념에 더 많은 주의가 필요합니다. 예시를 다시 살펴보고 단계별로 이해를 쌓아 보세요.',

    // Slide component – learning content layout labels
    'slide.content.pictureThis': '이 상황을 상상해 보세요:',
    'slide.content.illustrativeExample': '예시 설명',
    'slide.content.learningObjective': '학습 목표',
    'slide.content.todaysQuestion': '오늘의 질문',
    'slide.content.summary': '요약',
    'slide.caseStudy.story': '이야기',
    'slide.caseStudy.meet': '등장인물',
    'slide.caseStudy.problem': '문제',
    'slide.caseStudy.choice': '선택',
    'slide.caseStudy.stopAndThink': '잠깐 생각해 봐요',
    'slide.caseStudy.risks': '무엇이 잘못될 수 있을까요?',
    'slide.caseStudy.whatHappened': '일어난 일',
    'slide.caseStudy.bigIdea': '중심 생각',
    'slide.caseStudy.itsLike': '이건 마치…',
    'slide.caseStudy.letsTalk': '이야기해 봐요',
    'slide.lab.goal': '목표',
    'slide.lab.prerequisites': '시작하기 전에',
    'slide.lab.tools': '도구',
    'slide.lab.steps': '단계',
    'slide.lab.expectedResult': '예상 결과',
    'slide.lab.checkpoint': '체크포인트',
    'slide.lab.deliverable': '결과물',
    'slide.lab.resources': '참고 자료',
    'slide.lab.copy': '복사',
    'slide.lab.copied': '복사됨',
    'slide.lab.timeBox': '{minutes}분',
    'slide.lab.kind.build': '만들기',
    'slide.lab.kind.debug': '디버그',
    'slide.lab.kind.extend': '확장하기',
    'slide.lab.artifact.prompt': '프롬프트',
    'slide.lab.artifact.code': '코드',
    'slide.lab.artifact.config': '설정',
    'slide.lab.artifact.command': '명령어',
    'slide.lab.artifact.template': '템플릿',
    'slide.lab.artifact.sample': '예시 자료',
    'slide.lab.artifact.checklist': '체크리스트',
    'slide.lab.kind.start': '시작하기',
    'slide.lab.files': '파일',
    'slide.lab.troubleshooting': '문제가 생기면',
    'slide.lab.explainPrefix': '새 용어',
    'slide.lab.successCriteria': '이렇게 할 수 있으면 됩니다',
    'slide.lab.predictPrefix': '먼저 예측하기',
    'slide.lab.youWritePrefix': '직접 쓰기',
    'slide.lab.showAnswerKey': '정답 보기 (내 답을 쓴 뒤에)',
    'slide.lab.revealPrefix': '예측 확인 (답한 뒤에)',
    'slide.lab.where.terminal': '터미널',
    'slide.lab.where.codeEditor': '코드 편집기',
    'slide.lab.where.browser': '브라우저',
    'slide.lab.where.app': '앱',
    'slide.lab.where.notebook': '노트북',
    'slide.lab.where.phone': '휴대폰',
    'slide.lab.where.document': '문서',
    'slide.lab.where.aiChat': 'AI 채팅',
    'slide.lab.where.spreadsheet': '스프레드시트',
    'slide.lab.where.adminConsole': '관리 콘솔',
    'slide.map.coreSkill': '배울 스킬',
    'slide.map.parts': '스킬의 전체 구성 — 오늘 배우는 부분 표시',
    'slide.map.partsNext': '스킬의 전체 구성 — 다음에 배울 부분',
    'slide.map.scope': '이번 세션',
    'slide.map.status.today': '오늘',
    'slide.map.status.earlier': '완료',
    'slide.map.status.later': '다음',
    'slide.example.inRealSystem': '실제 시스템에서',
    'slide.example.notice': '눈여겨볼 부분',
    'slide.example.takeaway': '정리',
    'slide.example.kind.json': 'JSON',
    'slide.example.kind.pseudocode': '의사코드',
    'slide.example.kind.log': '로그',
    'slide.example.kind.flow': '흐름',
    'slide.example.kind.table': '표',
    'slide.overview.why': '왜 필요한가',
    'slide.overview.coreIdea': '한 문장으로 말하면',
    'slide.overview.finalResult': '오늘 만들 것',
    'slide.overview.howItWorks': '작동 방식',
    'slide.overview.tools': '사용할 도구',
    'slide.overview.youWillNeed': '준비물',
    'slide.prep.title': '시작하기 전에',
    'slide.prep.badge': '스스로 학습 · 약 {n}분 · 수업 시간 외',
    'slide.prep.badgeNoTime': '스스로 학습 · 수업 시간 외',
    'slide.prep.search': '검색어: {phrase}',
    'slide.prep.withGrownUp': '어른과 함께 읽어요',
    'slide.narrative.oldWorkflow': '기존 워크플로',
    'slide.narrative.before': '이전',
    'slide.narrative.newWorkflow': '새로운 워크플로',
    'slide.narrative.after': '이후',
    'slide.narrative.temptingShortcut': '유혹적인 지름길',
    'slide.narrative.theShortcut': '지름길',
    'slide.narrative.safetyBuffer': '안전 장치',
    'slide.narrative.thoughtfulResponse': '신중한 대응',
    'slide.narrative.shortcutTaken': '지름길 선택 시',
    'slide.narrative.catastrophicOutcome': '치명적인 결과',
    'slide.narrative.downstreamOutcome': '후속 영향:',
    'slide.spectrum.wrongMindset': '잘못된 사고방식',
    'slide.spectrum.rightMindset': '올바른 사고방식',
    'slide.sequence.beforeOperations': '1. 실행 전',
    'slide.sequence.firstSteps': '1. 초기 단계',
    'slide.sequence.afterOperations': '2. 실행 후',
    'slide.sequence.nextActions': '2. 다음 조치',
    'slide.modifier.watchOuts': '주의사항',
    'slide.modifier.whatThisIsNot': '이것이 아닌 것:',
    'slide.outcome.ifYouDoThisWell': '이를 잘 실천했을 때',
    'slide.outcome.ifYouSkipThis': '이를 건너뛰었을 때',
    'slide.reveal.correct': '정답입니다',
    'slide.reveal.incorrect': '정답은 다음과 같습니다',
    'slide.reentry.walkedInWith': '시작할 때의 생각',
    'slide.reentry.walkedOutWith': '배운 후 얻어가는 것',
    'slide.reentry.situation': '상황',
    'slide.reentry.goBackTo': '돌아가서 복습하기',
    'slide.recap.titleDefault': '종합 정리',
    'slide.recap.ourBigQuestion': '핵심 질문:',
    'slide.recap.shortAnswer': '간단한 답변:',
    'slide.recap.howWhatYouLearned': '배운 내용이 이 답변을 뒷받침하는 방법:',
    'slide.shareWork.starterScenario': '시작 시나리오',
    'slide.shareWork.successCriteria': '성공 기준',
    'slide.shareWork.tacticalTip': '실전 팁:',
    'slide.analysis.howToApply': '적용 방법:',
    'slide.workedExample.takeaway': '핵심 포인트:',
    'slide.pledge.iPledge': '서약합니다',
    'slide.video.notSupported': '브라우저가 동영상 태그를 지원하지 않습니다.',
  },

  'vi-VN': {
    // Duration formatting
    'duration.minutes': 'phút',
    'duration.hour': 'giờ',
    'duration.hours': 'giờ',
    'duration.and': 'và',
    
    // Outline page
    'outline.editModeActive': 'Chế độ chỉnh sửa đang bật',
    'outline.tooltip.saveChanges': 'Lưu thay đổi',
    'outline.tooltip.editProgramName': 'Chỉnh sửa tên chương trình',
    'outline.tooltip.download': 'Tải xuống',
    'outline.tooltip.exitEditMode': 'Thoát chế độ chỉnh sửa',
    'outline.tooltip.editOutlineContent': 'Chỉnh sửa nội dung dàn ý',
    'outline.tooltip.edit': 'Chỉnh sửa',
    'outline.tooltip.collapseDetails': 'Thu gọn để ẩn chi tiết',
    'outline.tooltip.expandDetails': 'Mở rộng để xem chi tiết',
    'outline.tooltip.removeItem': 'Xóa mục này',

    'outline.btn.save': 'Lưu',
    'outline.btn.saving': 'Đang lưu...',
    'outline.btn.cancel': 'Hủy',
    'outline.btn.startOver': 'Làm lại từ đầu',
    'outline.btn.generateProgram': 'Tạo chương trình',
    'outline.btn.goBack': 'Quay lại',
    'outline.btn.discard': 'Bỏ',
    'outline.btn.saveChanges': 'Lưu thay đổi',
    'outline.btn.yesRemove': 'Có, xóa',
    'outline.btn.yesGenerate': 'Có, tạo',

    'outline.title.suffix': 'Dàn ý chương trình',
    'outline.placeholder.enterProgramName': 'Nhập tên chương trình',

    'outline.section.learners': 'Người học',
    'outline.section.programStructure': 'Cấu trúc chương trình',
    'outline.section.programLength': 'Thời lượng chương trình',
    'outline.section.overview': 'Tổng quan:',
    'outline.section.sessionLearningObjectives': 'Mục tiêu học tập của buổi học:',

    'outline.structure.summary': '{modules} Mô-đun / {units} Đơn vị / {sessions} Buổi học',
    'outline.duration.minutes': '{minutes} phút',
    'outline.duration.totalMinutes': '(tổng {minutes} phút)',
    'outline.label.moduleWithIndex': 'Mô-đun {index}: {title}',
    'outline.label.unitWithIndex': 'Đơn vị {index}: {title}',
    'outline.label.sessionWithIndex': 'Buổi {index}: {title}',

    'outline.educator': 'Giáo viên',
    'outline.learner': 'Người học',
    'outline.ksab.knowledge': 'Kiến thức',
    'outline.ksab.skills': 'Kỹ năng',
    'outline.ksab.attitudes': 'Thái độ',
    'outline.ksab.behaviours': 'Hành vi',

    'outline.frameworksAligned': 'Khung tham chiếu liên kết',
    'outline.noFrameworksAligned': 'Không có khung tham chiếu liên kết cho mô-đun này',

    'outline.targetGroup.general': 'Công chúng',
    'outline.targetGroup.children': 'Trẻ em',
    'outline.targetGroup.teens': 'Thiếu niên',
    'outline.targetAge.8_9': '8–9 tuổi',
    'outline.targetAge.10_12': '10–12 tuổi',
    'outline.targetAge.13_14': '13–14 tuổi',
    'outline.targetAge.15_18': '15–18 tuổi',
    'outline.targetAge.allAges': 'Mọi lứa tuổi',
    'outline.targetAge.workforce': 'Lực lượng lao động',
    'outline.targetTier.T1': 'Tiểu học cấp dưới (7–9 tuổi)',
    'outline.targetTier.T2': 'Tiểu học cấp trên (10–12 tuổi)',
    'outline.targetTier.T3': 'Trung học cơ sở (13–14 tuổi)',
    'outline.targetTier.T4': 'Trung học phổ thông (15–17 tuổi)',
    'outline.targetTier.T5': 'Đại học/Cao đẳng (18–22 tuổi)',
    'outline.targetTier.T6': 'Công chúng (Mọi lứa tuổi)',
    'outline.targetTier.T7': 'Lực lượng lao động',

    'outline.toast.editNotAvailableEnglish': 'Không thể chỉnh sửa ở tiếng Anh. Vui lòng chọn ngôn ngữ khác.',
    'outline.toast.failedOpenPdf': 'Không thể mở PDF',
    'outline.toast.failedSaveOutline': 'Không thể lưu dàn ý',
    'outline.toast.failedRemoval': 'Không thể hoàn tất thao tác xóa',

    'outline.dialog.removeItem.title': 'Bạn có chắc muốn xóa {type} này không?',
    'outline.dialog.removeProgram.html': 'Bạn có chắc muốn xóa chương trình này không?<br/>Thao tác này không thể hoàn tác.',
    'outline.dialog.lastItem.title.program': 'Cảnh báo: Xóa chương trình hiện tại',
    'outline.dialog.lastItem.title.module': 'Cảnh báo: Xóa mô-đun',
    'outline.dialog.lastItem.title.unit': 'Cảnh báo: Xóa đơn vị',
    'outline.dialog.lastItem.body.program.html':
      'Đây là {type} cuối cùng trong chương trình.<br/>Việc xóa sẽ <strong>xóa toàn bộ chương trình hiện tại</strong> và tạo một chương trình mới.<br/>Bạn có chắc muốn tiếp tục? Thao tác này không thể hoàn tác.',
    'outline.dialog.lastItem.body.module.html':
      'Đây là {type} cuối cùng trong mô-đun này.<br/>Xóa {type} này cũng sẽ <strong>xóa toàn bộ mô-đun</strong>.<br/>Bạn có chắc muốn tiếp tục? Thao tác này không thể hoàn tác.',
    'outline.dialog.lastItem.body.unit.html':
      'Đây là {type} cuối cùng trong đơn vị này.<br/>Xóa {type} này cũng sẽ <strong>xóa toàn bộ đơn vị</strong>.<br/>Bạn có chắc muốn tiếp tục? Thao tác này không thể hoàn tác.',
    'outline.dialog.lastItem.confirm.program': 'Có, xóa chương trình',
    'outline.dialog.lastItem.confirm.module': 'Có, xóa mô-đun',
    'outline.dialog.lastItem.confirm.unit': 'Có, xóa đơn vị',

    'outline.dialog.generate.body.html':
      'Bạn có chắc muốn tạo chương trình này với <b>{count} buổi học?</b><br/>Sau khi tạo, bạn sẽ không thể chỉnh sửa và sẽ bị tính phí theo số buổi học được tạo.',

    'outline.dialog.unsaved.title': 'Thay đổi chưa được lưu',
    'outline.dialog.unsaved.body': 'Bạn có thay đổi chưa được lưu. Hãy lưu ngay hoặc chúng sẽ bị bỏ.',

    // Outline PDF/HTML documents
    'outlineDoc.title.prefix': 'Đề cương chương trình cho',
    'outlineDoc.viewType.educator': 'Chế độ xem giáo viên',
    'outlineDoc.viewType.learner': 'Chế độ xem học viên',
    'outlineDoc.meta.learners': 'Học viên:',
    'outlineDoc.meta.programStructure': 'Cấu trúc chương trình:',
    'outlineDoc.meta.programLength': 'Thời lượng chương trình:',
    'outlineDoc.meta.notSpecified': 'Chưa xác định',
    'outlineDoc.structure.modules': 'Mô-đun',
    'outlineDoc.structure.units': 'Đơn vị',
    'outlineDoc.structure.sessions': 'Phiên',
    'outlineDoc.section.overview': 'Tổng quan:',
    'outlineDoc.ksab.label': 'KSAB:',
    'outlineDoc.ksab.knowledge': 'Kiến thức',
    'outlineDoc.ksab.skills': 'Kỹ năng',
    'outlineDoc.ksab.attitudes': 'Thái độ',
    'outlineDoc.ksab.behaviours': 'Hành vi',
    'outlineDoc.dqCode.label': 'Mã DQ:',
    'outlineDoc.module.label': 'Mô-đun',
    'outlineDoc.unit.label': 'Đơn vị',
    'outlineDoc.session.label': 'Phiên',
    'outlineDoc.session.learningObjectives': 'Mục tiêu học tập của phiên:',
    'outlineDoc.frameworksAligned': 'Khung tham chiếu phù hợp:',
    'outlineDoc.noFrameworks': 'Không có khung tham chiếu nào phù hợp với chương trình này',
    'outlineDoc.footer.copyright': 'DQ LAB Pte Ltd. Bảo lưu mọi quyền. Powered by DQ',
    'outlineDoc.footer.trademark': 'là nhãn hiệu đã đăng ký của DQ LAB Pte Ltd.',

    // Teaching Plan PDF/HTML documents
    'teachingPlan.title.suffix': 'Kế hoạch giảng dạy cho giáo viên',
    'teachingPlan.meta.learners': 'Học viên:',
    'teachingPlan.meta.programStructure': 'Cấu trúc chương trình:',
    'teachingPlan.meta.programLength': 'Thời lượng chương trình:',
    'teachingPlan.meta.notSpecified': 'Chưa xác định',
    'teachingPlan.structure.modules': 'Mô-đun',
    'teachingPlan.structure.units': 'Đơn vị',
    'teachingPlan.structure.sessions': 'Phiên',
    'teachingPlan.section.overview': 'Tổng quan',
    'teachingPlan.section.preparingClass': 'Chuẩn bị lớp học của bạn',
    'teachingPlan.prep.beforeBeginning': 'Trước khi bắt đầu chương trình:',
    'teachingPlan.prep.internetAccess': 'Đảm bảo lớp học của bạn có {bold1} và {bold2} (máy tính hoặc máy tính bảng).',
    'teachingPlan.prep.internetAccessBold1': 'kết nối internet',
    'teachingPlan.prep.internetAccessBold2': 'thiết bị kỹ thuật số',
    'teachingPlan.prep.studentAccounts': 'Xác nhận tất cả học sinh có tài khoản và có thể đăng nhập vào {link}.',
    'teachingPlan.prep.studentAccountsLink': 'www.dqforall.com',
    'teachingPlan.prep.websiteBlocked': 'Nếu trang web bị chặn, hãy yêu cầu {bold} của bạn thêm vào danh sách trắng hoặc bỏ chặn.',
    'teachingPlan.prep.websiteBlockedBold': 'quản trị viên hệ thống',
    'teachingPlan.prep.headphones': 'Khuyến khích học sinh mang {bold} (một số hoạt động bao gồm video hoặc âm thanh).',
    'teachingPlan.prep.headphonesBold': 'tai nghe',
    'teachingPlan.module.label': 'Mô-đun',
    'teachingPlan.unit.label': 'Đơn vị',
    'teachingPlan.session.label': 'Phiên',
    'teachingPlan.session.untitled': 'Phiên không có tiêu đề',
    'teachingPlan.session.learningObjectives': 'Mục tiêu học tập của phiên',
    'teachingPlan.table.estimatedTime': 'Thời gian ước tính',
    'teachingPlan.table.segment': 'Phân đoạn',
    'teachingPlan.table.activities': 'Hoạt động',
    'teachingPlan.table.description': 'Mô tả',
    'teachingPlan.table.minutes': 'phút',
    'teachingPlan.segment.introduction': 'Giới thiệu',
    'teachingPlan.segment.introduction.activity1': 'Xem slide nội dung',
    'teachingPlan.segment.introduction.activity2': 'Xem video giới thiệu',
    'teachingPlan.segment.introduction.description': 'Học sinh được giới thiệu về chủ đề phiên và mục tiêu học tập.',
    'teachingPlan.segment.preAssessment': 'Đánh giá trước',
    'teachingPlan.segment.preAssessment.activity1': 'Hoàn thành câu hỏi đánh giá',
    'teachingPlan.segment.preAssessment.activity2': 'Tự đánh giá',
    'teachingPlan.segment.preAssessment.description': 'Học sinh hoàn thành bài đánh giá trước để đo lường kiến thức hiện có về chủ đề.',
    'teachingPlan.segment.learningObjective': 'Mục tiêu học tập',
    'teachingPlan.segment.slo.activity1': 'Hoạt động tương tác',
    'teachingPlan.segment.slo.activity2': 'Thực hành có hướng dẫn',
    'teachingPlan.segment.slo.activity3': 'Trả lời khảo sát',
    'teachingPlan.segment.slo.activity4': 'Áp dụng khái niệm',
    'teachingPlan.segment.slo.description': 'Học sinh tham gia vào nội dung học tập thông qua các hoạt động tương tác.',
    'teachingPlan.segment.mainContent': 'Nội dung chính',
    'teachingPlan.segment.mainContent.activity1': 'Hoạt động học tập tương tác',
    'teachingPlan.segment.mainContent.activity2': 'Khám phá có hướng dẫn',
    'teachingPlan.segment.mainContent.activity3': 'Thảo luận nhóm',
    'teachingPlan.segment.mainContent.description': 'Học sinh tham gia vào nội dung học tập cốt lõi thông qua các hoạt động tương tác và thảo luận.',
    'teachingPlan.segment.reflection': 'Suy ngẫm',
    'teachingPlan.segment.reflection.activity1': 'Suy ngẫm cá nhân',
    'teachingPlan.segment.reflection.activity2': 'Trả lời câu hỏi suy ngẫm',
    'teachingPlan.segment.reflection.activity3': 'Chia sẻ hiểu biết',
    'teachingPlan.segment.reflection.description': 'Học sinh suy ngẫm về việc học của mình và chia sẻ những điểm chính với bạn bè.',
    'teachingPlan.segment.postAssessment': 'Đánh giá sau',
    'teachingPlan.segment.postAssessment.activity1': 'Hoàn thành câu hỏi đánh giá',
    'teachingPlan.segment.postAssessment.activity2': 'Xem lại câu trả lời',
    'teachingPlan.segment.postAssessment.description': 'Học sinh hoàn thành bài đánh giá sau để chứng minh sự hiểu biết về các khái niệm đã học.',
    'teachingPlan.segment.recap': 'Tóm tắt',
    'teachingPlan.segment.recap.activity1': 'Xem lại các khái niệm chính',
    'teachingPlan.segment.recap.activity2': 'Phiên hỏi đáp',
    'teachingPlan.segment.recap.activity3': 'Tổng kết',
    'teachingPlan.segment.recap.description': 'Các điểm học tập chính được xem lại và củng cố để đảm bảo sự hiểu biết.',
    'teachingPlan.section.teacherNotes': 'Ghi chú của giáo viên',
    'teachingPlan.notes.note1': 'Duy trì môi trường lớp học cởi mở và tò mò.',
    'teachingPlan.notes.note2': 'Củng cố bài học liên tục bằng cách kiểm tra với học sinh sau mỗi phần tóm tắt phiên sử dụng các cuộc thảo luận nhóm trực tiếp hoặc các hoạt động suy ngẫm nhanh.',
    'teachingPlan.notes.note3': 'Theo dõi tiến độ và tác động thông qua {bold} của bạn.',
    'teachingPlan.notes.note3Bold': 'Bảng điều khiển trường học Powered by DQ',
    'teachingPlan.footer.copyright': 'DQ LAB Pte Ltd. Bảo lưu mọi quyền. Powered by DQ',
    'teachingPlan.footer.trademark': 'là nhãn hiệu đã đăng ký của DQ LAB Pte Ltd.',

    // Preview page
    'preview.editModeActive': 'Chế độ chỉnh sửa đang bật',
    'preview.preAssessment': 'Đánh giá trước',
    'preview.postAssessment': 'Đánh giá sau',
    'preview.deck.download': 'Tải HTML',
    'preview.deck.preparing': 'Đang chuẩn bị HTML…',
    'preview.deck.failed': 'Không thể chuẩn bị trang chiếu để tải xuống. Vui lòng thử lại.',
    'preview.deck.noVideo': 'Không có video',
    'preview.deck.slideCount': '{count} trang chiếu',
    'preview.deck.noSlides': 'Chưa có trang chiếu',
    'preview.assessment.quickTestFirst': 'Hãy làm một bài kiểm tra nhanh trước nhé!',
    'preview.assessment.testKnowledgeSkills': 'Hãy kiểm tra kiến thức và kỹ năng của bạn!',
    'preview.assessment.introAlt': 'Giới thiệu bài đánh giá',
    'preview.assessment.introTitle': 'Giới thiệu bài đánh giá',
    'preview.assessment.noQuestions': 'Không có câu hỏi.',
    'preview.tooltip.exitEditMode': 'Thoát chế độ chỉnh sửa',
    'preview.tooltip.editNotAvailableEnglish': 'Không thể chỉnh sửa nội dung chỉ bằng tiếng Anh',
    'preview.tooltip.editToggleLanguage': 'Chỉnh sửa chỉ khả dụng cho phiên bản ngôn ngữ khác. Chuyển sang ngôn ngữ khác để chỉnh sửa.',
    'preview.tooltip.editSlideContent': 'Chỉnh sửa nội dung slide',
    'preview.btn.viewNextSession': 'Xem buổi học tiếp theo',
    'preview.btn.viewNextSegment': 'Xem phân đoạn tiếp theo',
    'preview.btn.hide': 'Ẩn',
    'preview.btn.unhide': 'Hiện',
    'preview.tts.voice': 'Giọng đọc',
    'preview.tts.noVoices': 'Chưa có giọng đọc',
    'preview.tts.rate': 'Tốc độ',
    'preview.tts.pitch': 'Cao độ',
    'preview.tts.volume': 'Âm lượng',
    'preview.segment.introduction': 'Giới thiệu',
    'preview.segment.reflection': 'Suy ngẫm',
    'preview.segment.recap': 'Tóm tắt',
    'preview.segment.sessionScore': 'Điểm phiên',
    'preview.toast.failedSave': 'Không thể lưu thay đổi. Vui lòng thử lại.',
    'preview.toast.ttsBrowser': 'Đọc văn bản có vấn đề với trình duyệt của bạn. Vui lòng nâng cấp trình duyệt hoặc thử trình duyệt khác.',
    'preview.toast.editNotAvailableEnglish': 'Không thể chỉnh sửa nội dung chỉ bằng tiếng Anh.',
    'preview.toast.editToggleLanguage': 'Chỉnh sửa chỉ khả dụng cho phiên bản ngôn ngữ khác. Vui lòng chuyển để xem nội dung ngôn ngữ khác.',
    'preview.toast.outlineNotReady': 'Dàn ý chương trình chưa sẵn sàng!',
    'preview.toast.sessionNotAvailable': 'Buổi học "{title}" không khả dụng.',
    'preview.toast.sessionGenerating': 'Đang tạo buổi học "{title}". Vui lòng đợi.',
    'preview.selectSession': 'Chọn một buổi học từ menu để xem nội dung',
    'preview.assessmentModal.hideConfirm': 'Ẩn đánh giá sẽ xóa cả đánh giá trước và sau cho học viên ở mọi buổi học trong toàn bộ mô-đun này.<br/>Bạn có chắc muốn tiếp tục?',
    'preview.assessmentModal.unhideConfirm': 'Khi bạn hiện đánh giá này, cả đánh giá trước và sau ở mọi buổi học trong mô-đun này sẽ hiện lại cho học viên.<br/>Bạn có chắc muốn tiếp tục?',
    'preview.error.slideLayoutNotFound': 'Lỗi: Không tìm thấy bố cục slide',
    'preview.loadingSlides': 'Đang tải slide...',
    'preview.sidebar.moduleWithIndex': 'Mô-đun {index}: {title}',
    'preview.sidebar.unitWithIndex': 'Đơn vị {index}: {title}',
    'preview.sidebar.sessionWithIndex': 'Buổi học {index}: {title}',
    'preview.sidebar.view': 'Xem',
    'preview.sidebar.loadingSegments': 'Đang tải phân đoạn...',
    'preview.sidebar.sessionActivitiesLine': 'Hoạt động · Suy ngẫm · Đánh giá',
    'preview.btn.viewPreviousSegment': 'Xem phân đoạn trước',
    'slide.activity.journalingTime': 'Giờ viết nhật ký!',
    'slide.activity.shareWorkTime': 'Giờ chia sẻ bài làm!',
    'slide.activity.pollTime': 'Giờ bình chọn!',
    'slide.activity.discussionTime': 'Giờ thảo luận!',
    'slide.activity.letsTalkAboutIt': 'Cùng thảo luận',
    'slide.activity.yourSessionScore': 'Điểm phiên của bạn',
    'slide.activity.journalingPlaceholder': 'Bắt đầu viết suy ngẫm của bạn tại đây...',
    'slide.activity.shareLinkPlaceholder': 'Dán link chia sẻ tại đây (vd: Google Drive, Dropbox, v.v.)',
    'slide.activity.save': 'Lưu',
    'slide.activity.submit': 'Gửi',
    'slide.assessment.moduleScoreTitle': 'Điểm đánh giá mô-đun {module}',
    'slide.assessment.moduleScoreTitleGeneric': 'Điểm đánh giá mô-đun',
    'slide.assessment.sessionScoreTitle': 'Điểm đánh giá của phiên',
    'slide.assessment.rubricLevel': 'Cấp độ',
    'slide.assessment.rubricDescription': 'Mô tả',
    'slide.assessment.rubricHigh': 'Cao',
    'slide.assessment.rubricModerate': 'Trung bình',
    'slide.assessment.rubricBasic': 'Cơ bản',
    'slide.assessment.rubricLow': 'Thấp',
    'slide.assessment.rubricHighDesc': 'Kết quả của bạn cho thấy bạn hiểu rất rõ chủ đề này. Hãy phát huy điểm mạnh và thử áp dụng những gì đã học vào các tình huống mới.',
    'slide.assessment.rubricModerateDesc': 'Kết quả của bạn cho thấy bạn hiểu khá tốt chủ đề này, nhưng vẫn còn một vài chỗ chưa vững. Hãy ôn lại những phần đó và tiếp tục luyện tập những gì bạn đã học.',
    'slide.assessment.rubricBasicDesc': 'Kết quả của bạn cho thấy bạn hiểu một số ý chính. Hãy ôn lại kiến thức cơ bản và luyện tập để củng cố kiến thức và kỹ năng của mình.',
    'slide.assessment.rubricLowDesc': 'Kết quả của bạn cho thấy các ý chính cần được chú ý nhiều hơn. Hãy xem lại các ví dụ và xây dựng sự hiểu biết của bạn từng bước một.',

    // Slide component – learning content layout labels
    'slide.content.pictureThis': 'Hãy hình dung điều này:',
    'slide.content.illustrativeExample': 'Ví dụ minh họa',
    'slide.content.learningObjective': 'Mục tiêu học tập',
    'slide.content.todaysQuestion': 'Câu hỏi hôm nay',
    'slide.content.summary': 'Tóm tắt',
    'slide.caseStudy.story': 'Câu chuyện',
    'slide.caseStudy.meet': 'Gặp gỡ',
    'slide.caseStudy.problem': 'Vấn đề',
    'slide.caseStudy.choice': 'Lựa chọn',
    'slide.caseStudy.stopAndThink': 'Dừng lại và suy nghĩ',
    'slide.caseStudy.risks': 'Điều gì có thể không ổn?',
    'slide.caseStudy.whatHappened': 'Điều gì đã xảy ra',
    'slide.caseStudy.bigIdea': 'Ý tưởng chính',
    'slide.caseStudy.itsLike': 'Giống như…',
    'slide.caseStudy.letsTalk': 'Cùng trao đổi',
    'slide.lab.goal': 'Mục tiêu',
    'slide.lab.prerequisites': 'Trước khi bắt đầu',
    'slide.lab.tools': 'Công cụ',
    'slide.lab.steps': 'Các bước',
    'slide.lab.expectedResult': 'Kết quả mong đợi',
    'slide.lab.checkpoint': 'Điểm kiểm tra',
    'slide.lab.deliverable': 'Sản phẩm cần nộp',
    'slide.lab.resources': 'Tài liệu tham khảo',
    'slide.lab.copy': 'Sao chép',
    'slide.lab.copied': 'Đã sao chép!',
    'slide.lab.timeBox': '{minutes} phút',
    'slide.lab.kind.build': 'Xây dựng',
    'slide.lab.kind.debug': 'Gỡ lỗi',
    'slide.lab.kind.extend': 'Mở rộng',
    'slide.lab.artifact.prompt': 'Prompt',
    'slide.lab.artifact.code': 'Mã',
    'slide.lab.artifact.config': 'Cấu hình',
    'slide.lab.artifact.command': 'Lệnh',
    'slide.lab.artifact.template': 'Mẫu',
    'slide.lab.artifact.sample': 'Tài liệu mẫu',
    'slide.lab.artifact.checklist': 'Danh sách kiểm tra',
    'slide.lab.kind.start': 'Bắt đầu',
    'slide.lab.files': 'Tệp',
    'slide.lab.troubleshooting': 'Nếu gặp sự cố',
    'slide.lab.explainPrefix': 'Mới',
    'slide.lab.successCriteria': 'Bạn đã làm được khi',
    'slide.lab.predictPrefix': 'Dự đoán trước',
    'slide.lab.youWritePrefix': 'Bạn tự viết',
    'slide.lab.showAnswerKey': 'Xem đáp án (sau khi bạn tự trả lời)',
    'slide.lab.revealPrefix': 'Kiểm tra dự đoán (sau khi trả lời)',
    'slide.lab.where.terminal': 'Terminal',
    'slide.lab.where.codeEditor': 'Trình soạn thảo mã',
    'slide.lab.where.browser': 'Trình duyệt',
    'slide.lab.where.app': 'Ứng dụng',
    'slide.lab.where.notebook': 'Sổ tay',
    'slide.lab.where.phone': 'Điện thoại',
    'slide.lab.where.document': 'Tài liệu',
    'slide.lab.where.aiChat': 'Trò chuyện AI',
    'slide.lab.where.spreadsheet': 'Bảng tính',
    'slide.lab.where.adminConsole': 'Bảng điều khiển quản trị',
    'slide.map.coreSkill': 'Kỹ năng',
    'slide.map.parts': 'Các phần của kỹ năng — phần hôm nay được đánh dấu',
    'slide.map.partsNext': 'Các phần của kỹ năng — phần tiếp theo',
    'slide.map.scope': 'Buổi học này',
    'slide.map.status.today': 'Hôm nay',
    'slide.map.status.earlier': 'Đã học',
    'slide.map.status.later': 'Sau này',
    'slide.example.inRealSystem': 'Trong một hệ thống thực tế',
    'slide.example.notice': 'Điều cần chú ý',
    'slide.example.takeaway': 'Điều rút ra',
    'slide.example.kind.json': 'JSON',
    'slide.example.kind.pseudocode': 'Mã giả',
    'slide.example.kind.log': 'Nhật ký',
    'slide.example.kind.flow': 'Luồng',
    'slide.example.kind.table': 'Bảng',
    'slide.overview.why': 'Vì sao điều này quan trọng',
    'slide.overview.coreIdea': 'Ý chính trong một câu',
    'slide.overview.finalResult': 'Bạn sẽ xây dựng gì',
    'slide.overview.howItWorks': 'Cách hoạt động',
    'slide.overview.tools': 'Công cụ sẽ dùng',
    'slide.overview.youWillNeed': 'Bạn cần chuẩn bị',
    'slide.prep.title': 'Trước khi bắt đầu',
    'slide.prep.badge': 'Tự học · khoảng {n} phút · ngoài giờ học',
    'slide.prep.badgeNoTime': 'Tự học · ngoài giờ học',
    'slide.prep.search': 'Tìm kiếm: {phrase}',
    'slide.prep.withGrownUp': 'Hãy đọc cùng người lớn nhé',
    'slide.narrative.oldWorkflow': 'Quy trình cũ',
    'slide.narrative.before': 'Trước',
    'slide.narrative.newWorkflow': 'Quy trình mới',
    'slide.narrative.after': 'Sau',
    'slide.narrative.temptingShortcut': 'Đường tắt cám dỗ',
    'slide.narrative.theShortcut': 'Đường tắt',
    'slide.narrative.safetyBuffer': 'Vùng đệm an toàn',
    'slide.narrative.thoughtfulResponse': 'Phản ứng thấu đáo',
    'slide.narrative.shortcutTaken': 'Khi chọn đường tắt',
    'slide.narrative.catastrophicOutcome': 'Hậu quả nghiêm trọng',
    'slide.narrative.downstreamOutcome': 'Hậu quả kéo theo:',
    'slide.spectrum.wrongMindset': 'Tư duy sai lầm',
    'slide.spectrum.rightMindset': 'Tư duy đúng đắn',
    'slide.sequence.beforeOperations': '1. Trước khi thực hiện',
    'slide.sequence.firstSteps': '1. Các bước đầu tiên',
    'slide.sequence.afterOperations': '2. Sau khi thực hiện',
    'slide.sequence.nextActions': '2. Các hành động tiếp theo',
    'slide.modifier.watchOuts': 'Lưu ý cảnh giác',
    'slide.modifier.whatThisIsNot': 'Những điều KHÔNG phải:',
    'slide.outcome.ifYouDoThisWell': 'Nếu bạn làm tốt điều này',
    'slide.outcome.ifYouSkipThis': 'Nếu bạn bỏ qua điều này',
    'slide.reveal.correct': 'Bạn đã trả lời đúng',
    'slide.reveal.incorrect': 'Câu trả lời đúng là',
    'slide.reentry.walkedInWith': 'Suy nghĩ khi bắt đầu',
    'slide.reentry.walkedOutWith': 'Điều bạn nhận được sau bài học',
    'slide.reentry.situation': 'Tình huống',
    'slide.reentry.goBackTo': 'Quay lại ôn tập',
    'slide.recap.titleDefault': 'Tổng kết toàn bộ',
    'slide.recap.ourBigQuestion': 'Câu hỏi lớn của chúng ta:',
    'slide.recap.shortAnswer': 'Câu trả lời ngắn gọn:',
    'slide.recap.howWhatYouLearned': 'Những gì bạn học củng cố cho câu trả lời này thế nào:',
    'slide.shareWork.starterScenario': 'Kịch bản khởi đầu',
    'slide.shareWork.successCriteria': 'Tiêu chí thành công',
    'slide.shareWork.tacticalTip': 'Mẹo thực tế:',
    'slide.analysis.howToApply': 'Cách áp dụng:',
    'slide.workedExample.takeaway': 'Bài học rút ra:',
    'slide.pledge.iPledge': 'Tôi cam kết',
    'slide.video.notSupported': 'Trình duyệt của bạn không hỗ trợ thẻ video.',
  },
};

export function normalizeUiLocale(input) {
  if (!input) return 'en-US';
  const raw = String(input);

  // Accept full locales as-is if supported
  if (TRANSLATIONS[raw]) return raw;

  // Accept language-only codes
  const base = raw.split('-')[0].toLowerCase();
  const map = {
    en: 'en-US',
    es: 'es-ES',
    ja: 'ja-JP',
    ko: 'ko-KR',
    th: 'th-TH',
    vi: 'vi-VN',
  };
  return map[base] || 'en-US';
}

export function isUiRtl(locale) {
  // No RTL locales in the supported set.
  return false;
}

export function pickUiLocaleFromProgram(programData) {
  // If the program has translations, prefer its non-English locale (if supported).
  const keys = programData && programData.translations && typeof programData.translations === 'object'
    ? Object.keys(programData.translations)
    : [];

  // Prefer a supported non-English locale
  const supportedNonEnglish = keys.find((k) => k && k !== 'en-US' && TRANSLATIONS[normalizeUiLocale(k)]);
  if (supportedNonEnglish) return normalizeUiLocale(supportedNonEnglish);

  // Otherwise, if English exists, use it
  if (keys.includes('en-US')) return 'en-US';

  return 'en-US';
}

function interpolate(template, vars) {
  if (!vars) return template;
  return String(template).replace(/\{(\w+)\}/g, (_, k) => {
    const v = vars[k];
    return v === undefined || v === null ? '' : String(v);
  });
}

export function tUi(key, locale, vars) {
  const normalized = normalizeUiLocale(locale);
  const dict = TRANSLATIONS[normalized] || TRANSLATIONS['en-US'];
  const fallback = TRANSLATIONS['en-US'];
  const value = dict[key] ?? fallback[key] ?? key;
  return interpolate(value, vars);
}

